import React, { Component } from 'react';
import { AddAgentIcon, DeepSpaceGrey } from '@core/theme/baseTheme';
import ClockIcon from '@assets/icons/clock-icon.svg';
import ProfileImage from '@assets/icons/default-profile-icon.svg';
import DeleteIcon from '@assets/icons/delete-icon.svg';
import DetailTaskIcon from '@assets/icons/detalle-task-icon.svg';
import editImageIcon from '@assets/icons/edit-icon.svg';
import RepositionSmallIcon from '@assets/icons/reposition-icon.svg';
import AssetsIcon from '@assets/icons/taskGroup-assets-icon.svg';
import FormIcon from '@assets/icons/taskGroup-form-icon.svg';
import ImagesIcon from '@assets/icons/taskGroup-image-icon.svg';
import InventoryIcon from '@assets/icons/taskGroup-inventory-icon.svg';
import RouteIcon from '@mui/icons-material/Route';
import CloseIcon from '@mui/icons-material/Close';
import {
  Container,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
  TextField,
  InputAdornment,
  Box, TableContainer, Paper
} from '@mui/material';
import { getAccountPreferences } from 'FielderUtils/accountUtils';
import ErrorCodes from 'FielderUtils/ErrorCodes';
import routeConst from 'FielderUtils/roleManagementConst/routeConst';
import { GOOGLE_URL_WITH_LIBRARIES } from 'FielderUtils/session/Session';
import TaskStatusConst from 'FielderUtils/status/taskStatus';
import { getPinColor } from 'FielderUtils/task/pinColor';
import { getSeverityText } from 'FielderUtils/task/taskSeverity';
import { getAllTaskTypeList, getTaskTypeParents, hasTaskTypeDynamoTable, listToTree } from 'FielderUtils/taskType/taskType';
import { DragDropContext, Draggable, Droppable } from '@hello-pangea/dnd';
import Grid from '@mui/material/Grid2'
import Button from '@mui/material/Button';
import { Scrollbars } from 'react-custom-scrollbars-2';
import DatePicker from 'react-datepicker';
import { connect } from 'react-redux';
import { motion } from 'framer-motion';
import { isRoleValid } from '../../core/utils/roles/validateRoles';
import AgentDetail from '../Agents/AgentDetailContainer';
import ErrorMessage from 'OldComponents/ErrorMessage/ErrorMessage';
import Map from '../Map';
import StatusFormatter from '../SmartTable/StatusFormatter';
import RouteStatus from '../Status/RouteStatus';
import TaskDetails from '../TaskDetails';
import EditExpenses from './EditExpenses';
import EditRouteEndPoint from './EditRouteEndPoint';
import TaskSearchResultsPopup from './TaskSearchResultPopup';
import './RouteDetails.css';
import 'FielderUtils/style.css';
import {
  doActionReorderRouteRequest,
  getRouteByIdRequest,
  getRouteTaskToShowRequest
} from '@core/api/route/route.service';
import { reorderArrayElementByIndex } from '@core/utils/array/reorder.utils';
import { useFielderSnackBar } from '~/FielderElements/useFielderSnackBar';
import Modal from '~/FielderElements/Modal';
import { FIELDER } from '@core/constants/base.constants';
import { FielderSmartNav } from '~/FielderElements/Utils/SmartTabNav';
import { FielderRootContainerXXL } from '~/FielderElements/FielderElements.component';
import RefreshOutlinedIcon from '@mui/icons-material/RefreshOutlined';
import { SmartIconButton } from '~/FielderElements/SmartTaskTable/SmartStyles';
import { AccountBalanceWallet, CalendarMonth, SearchOutlined, SwapVert } from '@mui/icons-material';
import SearchIcon from '@mui/icons-material/Search';
import { FielderButton } from 'OldComponents/ui';

const { pop: POP_ID } = FIELDER.idElement;
const POP_EDIT_AGENT = POP_ID.routeDetail.replace('{0}', 'editAgentModal');
var Request = require('FielderRequestTypes');
const LOC_ACTIVITY_TYPE = 'activity_type_';
var moment = require('moment-timezone');
const activityRowSx = {
  borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
  '&:hover': { bgcolor: (theme) => theme.palette.action.hover },
};
const activityCellSx = {
  py: 1,
  fontSize: 13,
  color: 'text.primary',
};
class RouteDetails extends Component {
	constructor(props) {
		super(props);
		this.editAgentModal = this.editAgentModal.bind(this);
		this.onChangeInitialMap = this.onChangeInitialMap.bind(this);
		this.state = {
			routeDetailsInfo: true,
			route: {},
			items: [],
			markers: [],
			originalMarkers: [],
			originalItems: [],
			routePoints: [],
			editable: false,
			add: false,
			loading: true,
			showActivity: false,
			position: 0,
			showRouteInfo: true,
			showEmergencies: false,
			from: null,
			to: null,
			opacity: 1,
			tasksToShow: [],
			showTasks: false,
			showDetailTask: false,
			idTask: null,
			errorMessage: false,
			limit: 50,
			offset: 0,
			mycount: 0,
			initialMap: true,
			origin: 'routeDetail',
			taskTypes: { taskTypeFunctionality: false, types: [] },
			kmCost: 'hola',
			startLocation: {},
			endLocation: {},
			configExpenses: false,
			isAllowedRouteEdit: false,
			isAllowedRouteAddTask: false,
			isAllowedReorganizeRoute: false,
			isAllowedDeleteTask: false,
		};
	}
	componentDidMount = () => {
		getAccountPreferences(this, this.props.session);
		let state = this.state;
		state.isAllowedRouteEdit = isRoleValid(routeConst.ROUTES, routeConst.EDIT, this.props.session.roles);
		state.isAllowedRouteAddTask = isRoleValid(routeConst.ROUTES, routeConst.ADD_TASK_BY_FOLIO, this.props.session.roles);
		state.isAllowedReorganizeRoute = isRoleValid(routeConst.ROUTES, routeConst.REORGANIZE_ROUTE, this.props.session.roles);
		state.isAllowedDeleteTask = isRoleValid(routeConst.ROUTES, routeConst.DELETE_TASK_FROM_ROUTE, this.props.session.roles);
		this.setState(state);
		hasTaskTypeDynamoTable().then((taskTypeFunctionality) => {
			if (taskTypeFunctionality) {
				getAllTaskTypeList(
					(formatTypes, taskTypes) => {
						let types = listToTree(formatTypes);
						let state = this.state;
						state.taskTypes.types = types;
						state.taskTypes.taskTypeFunctionality = taskTypeFunctionality;
						this.setState(state);
					},
					this.props,
					true
				);
			}
		});
		const onSuccess = (response) => {
			this.renderRouteResponse(response);
		}
		const loadingConfig = { dispatch: this.props.dispatch }
		getRouteByIdRequest(Request.getRouteById(this.props.idRoute), onSuccess, null, loadingConfig);
	};
	getListStyle = (isDraggingOver) => ({ background: 'white', padding: 8, height: '100%', width: '100%' });
	getItemStyle = (isDragging, draggableStyle) => ({
		userSelect: 'none',
		MozUserSelect: 'none',
		padding: 16,
		margin: `0 0 8px 0`,
		background: isDragging ? '#4a4a4a4a' : 'transparent',
		...draggableStyle,
	});
	onDragEnd = (e) => {
		if (!e.destination || e.source.index === e.destination.index) return;
		const items = reorderArrayElementByIndex(this.state.items, e.source.index, e.destination.index);
		this.setState({ items });
	}
	onChangeTaskPosition = (event) => {
		this.setState({ position: event.target.value });
	};
	renderReorderRoute = (res) => {
		const routeResponse = res;
		if (routeResponse.success) {
			this.setState({ route: routeResponse.route, items: routeResponse.route.tasks, editable: false });
			this.getMarkers();
		}
	};
	canUpdateRoute = (tasks) => {
		let canUpdateRoute = true;
		let prevStatus, currentStatus;
		if (tasks.length !== 0) {
			prevStatus = tasks[0].status;
			for (let index = 0; index < tasks.length; index++) {
				currentStatus = tasks[index].status;
				if (
					(prevStatus === TaskStatusConst.MANAGING ||
						prevStatus === TaskStatusConst.WAITING_FOR_AGENT ||
						prevStatus === TaskStatusConst.IN_PROGRESS) &&
					(currentStatus === TaskStatusConst.FINISH ||
						currentStatus === TaskStatusConst.EXECUTING ||
						currentStatus === TaskStatusConst.START_ROUTE ||
						currentStatus === TaskStatusConst.ARRIVED)
				) {
					canUpdateRoute = false;
					break;
				}
				prevStatus = tasks[index].status;
			}
		} else canUpdateRoute = false;
		return canUpdateRoute;
	};
	updateTaskOrders = () => {
		const route = this.state.route;
		route.tasks = this.state.items;
		if (this.canUpdateRoute(route.tasks)) {
			route.endPoint = this.state.endLocation;
			route.startPoint = this.state.startLocation;
			let body = Request.getOrderRoute(route);
			const onSuccess = (response) => {
				this.renderReorderRoute(response);
				this.props.fielderMsg({
          message: this.props.lan.savedCorrectly, variant: 'success', closeButton: true, duration: 5000});
			}
			const onError = (response) => {
				if (response.errorCode === ErrorCodes.ROUTE_MODIFIED_BY_AGENT) {
					this.props.fielderMsg({
            message: this.props.lan.routeChangedByAgent, variant:  'warning', closeButton: true, duration: 6000});
					this.refresh();
				} else this.props.fielderMsg({
          message: this.props.lan.unexpectedErrorOcurred, variant: 'error', closeButton: true, duration: 5000});
			}
			const loadingConfig = { dispatch: this.props.dispatch }
			doActionReorderRouteRequest(body, onSuccess, onError, loadingConfig);
		} else this.props.fielderMsg({
      message: this.props.lan.messageUpdateRoute, variant:  'warning', closeButton: true, duration: 6000});
	};
	showDetailTask = (id) => {
		if (id && id > 0) this.setState({ showDetailTask: true, idTask: id });
	};
	showDetailTaskDetail = (id) => {
		if (id && id > 0) this.setState({ showDetailTask: true, idTask: id });
	};
	getMarkerDescription = (task, position) => {
		let description = '';
		const priority = task?.severity ? task.severity : task.priority;
		const priorityName = task?.severityName ? task.severityName : task.priorityName;
		if (position) description = description + ' ( ' + position + ' ) ';
		let taskFolio = task.folio ? task.folio : '';
		if (task.idTask)
      description = description + '\n- ' + this.props.lan.task + ': ' + task.idTask + ' [' + taskFolio + ']';
		if (task.severity)
      description = description + '\n- ' + this.props.lan.priority + ': ' + getSeverityText(priority, this.props.lan, priorityName);
		if (task.branch) {
			description = description + '\n- '+ this.props.lan.branch + ': ' + task.branch.name;
		} else if (task.user && task.user.branch) {
			description = description + '\n- '+ this.props.lan.branch + ': ' + + task.user.branch.name;
		} else if (task.user) description = description + '\n- '+ this.props.lan.client + ': ' + + task.user.name;
		return description;
	};
	setDefaultTasksMarkers() {
		const markers = [];
		const routePoints = [];
		const component = this;
		this.state.items.forEach(function (element, index) {
			const loc = element.startLocation;
			let color = getPinColor([element], 0);
			const position = index + 1;
			markers.push({
				coordinates: { lat: parseFloat(loc.latitude), lng: parseFloat(loc.longitud) },
				pin: color,
				draggable: false,
				id: element.idTask,
				onMarkerClick: (id) => component.showDetailTask(id),
				description: component.getMarkerDescription(element, position),
			});
			routePoints.push({
				coordinates: { lat: parseFloat(loc.latitude), lng: parseFloat(loc.longitud) },
				pin: color,
				draggable: false,
			});
		});
		var latitude = '18.4316459';
		var longi = '-100.2870970';
		for (let i = 0; i < this.state.route.emergencies.length; i++) {
			let color = 'yellow';
			markers.push({
				coordinates: {
					lat: parseFloat(this.state.route.emergencies[i].latitude),
					lng: parseFloat(this.state.route.emergencies[i].longitude),
				},
				pin: color,
				draggable: false,
				description: this.state.route.emergencies[i].emergencyText
					? this.state.route.emergencies[i].emergencyText
					: '',
			});
		}
		this.setState({ markers: markers, routePoints: routePoints });
	};
	getAgentMarkerDescription = (agent) => {
		let description = '';
		if (agent) {
			const name = agent.name ? agent.name : '';
			const lname = agent.lastName ? agent.lastName : '';
			const agentCompanyName = agent.companyName ? agent.companyName : '';
			description = '- '+name + ' ' + lname+ '\n- '+ this.props.lan.company+': '+agentCompanyName;
			return description;
		}
		return description;
	};
	showDetailAgent = (id) => {
		if (id && id > 0) {
			this.setState({ showDetailAgent: true, idAgent: id },
        () => {
        this.editAgentModal();
      });
		}
	};
	getEndPoint = () => {
		if (this.state.route && this.state.route.endPoint) {
			var endPoint = this.state.route.endPoint;
			var pin = 'end-route';
      return {
        coordinates: { lat: parseFloat(endPoint.latitude), lng: parseFloat(endPoint.longitud) },
        pin: pin,
        draggable: false,
        id: endPoint.idLocation,
        description: this.props.lan.routeEndPoint,
      };
		}
		return null;
	};
	getMarkers = () => {
		const markers = [];
		const routePoints = [];
		const component = this;
		var agentLocation = null;
		if (
			this.state.route &&
			this.state.route.agent &&
			(this.state.route.agent.geolocation || this.state.route.agent.location)
		) {
			var loc = null;
			if (this.state.route.status === 3 && this.state.route.agent.geolocation) {
				loc = this.state.route.agent.geolocation;
			} else if (this.state.route.agent.location) loc = this.state.route.agent.location;
			if (loc != null) {
				const agent = this.state.route.agent;
				if (loc.activeIcon === true) {
					var pin = 'agent';
				} else var pin = 'inactiveAgent';
				agentLocation = {
					coordinates: { lat: parseFloat(loc.latitude), lng: parseFloat(loc.longitud) },
					pin: pin,
					draggable: false,
					id: agent.idAgent,
					onMarkerClick: (id) => this.showDetailAgent(id),
					description: this.getAgentMarkerDescription(agent),
				};
				markers.push(agentLocation);
			}
		}
		if (agentLocation != null) {
			var coords = agentLocation.coordinates;
			routePoints.push({ coordinates: coords, pin: 'agentroute', draggable: false });
		}
		this.state.items.forEach(function (element, index) {
			const loc = element.startLocation;
			let color = getPinColor([element], 0);
			const position = index + 1;
			let latitude = parseFloat(loc.latitude);
			let longitud = parseFloat(loc.longitud);
			markers.push({
				coordinates: { lat: latitude, lng: longitud },
				pin: color,
				draggable: false,
				id: element.idTask,
				onMarkerClick: (id) => component.showDetailTask(id),
				description: component.getMarkerDescription(element, position),
			});
			routePoints.push({ coordinates: { lat: latitude, lng: longitud }, pin: color, draggable: false });
		});
		this.state.tasksToShow.forEach(function (element, index) {
			const loc = element.startLocation;
			let color = getPinColor([element], 0);
			markers.push({
				coordinates: { lat: parseFloat(loc.latitude), lng: parseFloat(loc.longitud) },
				pin: color,
				draggable: false,
				id: element.idTask,
				onMarkerClick: (id) => component.showDetailTask(id),
				description: component.getMarkerDescription(element),
			});
		});
		var endPointLocation = this.getEndPoint();
		if (endPointLocation) {
			routePoints.push({ coordinates: endPointLocation.coordinates, pin: 'agentroute', draggable: false });
			markers.push(endPointLocation);
		}
		var latitude = '18.4316459';
		var longi = '-100.2870970';
		for (let i = 0; i < this.state.route.emergencies.length; i++) {
			let tz = this.state.timeZone;
			let ft = 'DD-MM-YYYY hh:mm a';
			let color = 'yellow';
			markers.push({
				coordinates: {
					lat: parseFloat(this.state.route.emergencies[i].latitude),
					lng: parseFloat(this.state.route.emergencies[i].longitude),
				},
				pin: color,
				draggable: false,
				description: this.state.route.emergencies[i].emergencyText
					? this.state.route.emergencies[i].emergencyText +
					  '  ' +
					  moment.tz(this.state.route.emergencies[i].createdDate, tz).format(ft)
					: '' + moment.tz(this.state.route.emergencies[i].createdDate, tz).format(ft),
			});
		}
		this.setState({ markers: markers, originalMarkers: markers, routePoints: routePoints });
	};
	getTimeZone = (route) => {
		if (route && route.tasks && route.tasks.length > 0) {
			if (route.tasks[0] && route.tasks[0].startLocation && route.tasks[0].startLocation.timeZone)
        return route.tasks[0].startLocation.timeZone;
		}
		return 'America/Mexico_City';
	};
	renderRouteResponse = (res) => {
    const routeResponse = res;
    if (routeResponse.route && routeResponse.route.expenses)
      this.calculateRouteExpenses(routeResponse.route, routeResponse.route.expenses);
    const routeData = this.calculateRouteData(routeResponse.route);
    routeResponse.route.km = routeData.kmCost;
    var startLocation;
    if (routeResponse.route.startPoint) {
      startLocation = routeResponse.route.startPoint;
    } else {
      startLocation = routeResponse.route.agent.location;
      startLocation.idLocation = 0;
    }
    var endLocation = routeResponse.route.endPoint;
    this.setState({
      loading: false,
      route: routeResponse.route,
      timeZone: this.getTimeZone(routeResponse.route),
      items: routeResponse.route.tasks,
      originalItems: routeResponse.route.tasks,
      routeExpensesPreferences: routeResponse.routeExpensesPreferences,
      km: routeData.km,
      kmRouteCost: '$ ' + routeData.kmCost,
      startLocation,
      endLocation,
    }, () => {
      setTimeout(() => this.getMarkers(), 10);
    });
    /*this.setState({
      loading: false,
      route: routeResponse.route,
      timeZone: this.getTimeZone(routeResponse.route),
      items: routeResponse.route.tasks,
      originalItems: routeResponse.route.tasks,
      routeExpensesPreferences: routeResponse.routeExpensesPreferences,
      km: routeData.km,
      kmRouteCost: '$ ' + routeData.kmCost,
      startLocation: startLocation,
      endLocation: endLocation,
    });
    this.getMarkers();*/
	};
	calculateRouteData = (route) => {
		const km = this.getKm(route.metersValue);
		const kmCost = this.getKMCost(route);
		return { kmCost: kmCost, km: km };
	};
	getKm = (value) => {
		let km = parseFloat(value) / 1000;
    return km + ' km';
	};
	getTime = (date) => {
		date = Number(date);
		const hours = Math.floor(date / 3600);
		const minutes = Math.floor((date % 3600) / 60);
		const seconds = Math.floor((date % 3600) % 60);
		const hoursDisplay =
			hours > 0
				? hours + (hours === 1 ? ' ' + this.props.lan.hour + ', ' : ' ' + this.props.lan.hours + ' ')
				: '';
		const minutesDisplay =
			minutes > 0
				? minutes +
				  (minutes === 1 ? ' ' + this.props.lan.minute + ', ' : ' ' + this.props.lan.minutes + ' ')
				: '';
		const secondsDisplay =
			seconds > 0
				? seconds +
				  (seconds === 1 ? ' ' + this.props.lan.second : ' ' + this.props.lan.seconds + ' ')
				: '';
		return hoursDisplay + minutesDisplay + secondsDisplay;
	};
	getTaskNumberSelect = () => this.state.items.map((item, i) => this.getOption(i));
	getOption = (element) => {
		return <option value={element}>{element + 1}</option>;
	};
	onIdTaskChange = (event) => {
		let value = event.target.value;
		if (value && value !== '') {
			this.setState({ idTask: value });
		} else this.setState({ idTask: undefined });
	};
	deleteTaskFromRoute = (index) => {
		let tasks = this.state.items;
		tasks.splice(index, 1);
		this.setState({ items: tasks });
	};
	formatDate = (dateInMillis) => {
		var formattedDate = moment(dateInMillis).format('DD-MM-YYYY HH:mm');
		return formattedDate;
	};
	handleFromDate = (date) => {
		if (date == null) {
			this.setState({ items: this.state.originalItems, tasksToShow: [], markers: [] });
			this.setDefaultTasksMarkers();
		}
		this.setState({ from: date });
	};
	handleToDate = (date) => {
		if (date && this.state.from && date.getTime() >= this.state.from.getTime()) {
			this.setState(
				{ to: date, offset: 0, tasksToShow: [] },
				() => this.getTasks()
			);
		}
	};
	getTasks = () => {
		const from = this.state.from;
		const to = this.state.to;
		const body = {
			requestType: 'GET_TASK_TO_SHOW',
			fromYear: from.getFullYear(),
			fromMonth: from.getMonth(),
			fromDay: from.getDate(),
			toYear: to.getFullYear(),
			toMonth: to.getMonth(),
			toDay: to.getDate(),
			offset: this.state.offset,
			limit: this.state.limit,
		};
		const onSuccess = this.renderTasks;
		const onError = console.log
		const loadingConfig = { dispatch: this.props.dispatch }
		getRouteTaskToShowRequest(body, onSuccess, onError, loadingConfig)
	};
	renderTasks = (res) => {
		let markers = this.state.originalMarkers;
		if (res) {
			if (res && res.services) {
				if (!markers && markers.length === 0) markers = [];
				if (res.services.length > 0) {
					const tasks = res.services;
					let allTasks = this.state.tasksToShow.concat(tasks);
					this.setState({
							markers: markers,
							tasksToShow: allTasks,
							mycount: res.total,
							showTasks: true,
							offset: this.state.offset + this.state.limit,
						},
						() => this.getMarkers()
					);
				}
			} else {
				this.setState({ markers: markers, showTasks: true, tasksToShow: [] }, () =>
					this.getMarkers()
				);
			}
		} else {
			this.setState({ markers: markers, showTasks: true, tasksToShow: [] }, () =>
				this.getMarkers()
			);
		}
	};
	handleKeyPress = (event) => {
		if (event.key === 'Enter') {
			this.setState({ showTasksResult: true, opacity: 0 });
		}
	};
	onChangeInitialMap() {
		if (this.state.initialMap) this.setState({ initialMap: false });
	};
	refresh = () => {
		let body = Request.getRouteById(this.props.idRoute);
		const onSuccess = this.renderRouteResponse;
		const loadingConfig = { dispatch: this.props.dispatch }
		getRouteByIdRequest(body, onSuccess, null, loadingConfig);
	};
	calculateRouteExpenses = (route, preferences) => {
		const kmCost = this.getKMCost(route);
		const kmCostWithExpenses = this.getKMCostWithExpenses(kmCost, preferences);
		const totalCost = this.getTotalCost(kmCostWithExpenses, preferences);
		this.setState({ kmCost: kmCost, kmCostWithExpenses: kmCostWithExpenses, totalCost: totalCost });
	};
	getTotalCost = (kmCostWithExpenses, preferences) => {
		var total = parseFloat(kmCostWithExpenses);
		if (preferences.defaultExpenses) {
			preferences.defaultExpenses.map((element, index) => {
				if (element.id !== 3) total = total + element.value;
			});
			preferences.dynamicExpenses.map((element, index) => {
				if (element.id !== 3) total = total + element.value;
			});
		}
		return total;
	};
	getKMCost = (props) => {
		try {
			let cost = ((props.metersValue * props.kmCost) / 1000).toFixed(2);
			return cost;
		} catch (error) {
			return 0.0;
		}
	};
	isValidThePercentageKm = (preferences) => {
		return (
			preferences &&
			preferences.defaultExpenses &&
			preferences.defaultExpenses.expensesKm &&
			typeof preferences.defaultExpenses.expensesKm === 'number' &&
			preferences.defaultExpenses.expensesKm > 0 &&
			preferences.defaultExpenses.expensesKm < 101
		);
	};
	getKMCostWithExpenses = (kmCost, preferences) => {
		try {
			let cost = kmCost;
			const isValid = this.isValidThePercentageKm(preferences);
			if (isValid) {
				let percentage = preferences.percentageKm;
				percentage = percentage / 100;
				percentage = percentage + 1;
				cost = (cost * percentage).toFixed(2);
			}
			return cost;
		} catch (error) {
			return 0.0;
		}
	};
	getActivityTime = (millis) => {
		const date = new Date(millis);
		var hour, minutes;
		if (date.getHours() < 10) {
			hour = '0' + date.getHours();
		} else hour = date.getHours();
		if (date.getMinutes() < 10) {
			minutes = '0' + date.getMinutes();
		} else minutes = date.getMinutes();
		return hour + ' : ' + minutes + ' hrs';
	};
	getActivityDate = (millis) => {
		const date = new Date(millis);
		const month = date.toLocaleString('es-es', { month: 'long' });
		return date.getDate() + ' - ' + month + ' - ' + date.getFullYear();
	};
	getActivityUser = (element) => {
		let name = '';
		let image = ProfileImage;
		if (element.agent) {
			name = element.agent.name + ' ' + element.agent.lastName;
			if (element.agent.profileImage) image = element.agent.profileImage;
		} else if (element.clientUser) {
			name = element.clientUser.name + ' ' + element.clientUser.lastName;
			if (element.clientUser.profileImage) {
				image = element.clientUser.profileImage.scalePath;
			}
		}
		return (
			<TableCell align='left'>
        <Grid container direction="row" sx={{ justifyContent: "center", alignItems: "center", }} spacing={1}>
          <Grid size={'auto'}>
            <Box component="img" width={38} src={image} roundedCircle />
          </Grid>
          <Grid size={'auto'}>
            <Typography variant={'caption'}>{name}</Typography>
          </Grid>
        </Grid>
			</TableCell>
		);
	};
	getEmergencyDate = (emergency) => {
		return moment.tz(emergency.createdDate, this.state.timeZone).format('DD-MM-YYYY hh:mm a');
	};
	setDefaultFalse() {
		this.setState({
			showTasksResult: false,
			opacity: 1,
		});
	};
	setDefaultFalseModal(task, position) {
		let tasks = this.state.items;
		var canInsert = true;
		for (let i = 0; i < this.state.items.length; i++) {
			if (task.idTask == this.state.items[i].idTask) canInsert = false;
		}
		if (canInsert) tasks.splice(position, 0, task);
		this.setState({ items: tasks });
		this.getMarkers();
		this.setState({ showTasksResult: false, opacity: 1 });
	};
	closePopup = () => this.setState({ errorMessage: !this.state.errorMessage });
  getListSx = (isDraggingOver) => ({
    p: 1,
    height: '100%',
    width: '100%',
    borderRadius: 1,
    outline: isDraggingOver ? '2px dashed' : 'none',
    outlineColor: (theme) => theme.palette.divider,
  });
  getItemSx = (isDragging) => ({
    userSelect: 'none',
    p: 2,
    mb: 1,
    width: '100%',
    bgcolor: (theme) =>
      isDragging
        ? (theme.palette.mode === 'dark' ? 'action.selected' : 'grey.100')
        : (theme.palette.mode === 'dark' ? 'background.paper' : 'common.white'),
    borderRadius: 1.5,
    boxShadow: 1,
    transition: 'background-color 120ms ease',
    ...(this.state.editable && {
      borderStyle: 'dashed',
      borderWidth: 1,
      borderColor: (theme) => theme.palette.divider,
    }),
  });

  getSeveritySx = (severity) => {
    const map = {
      high: '#FF4146',
      med:  '#FE8B0D',
      low:  '#FFCF00',
    };
    const key =
      severity >= 3 ? 'high' :
        severity === 2 ? 'med' :
          'low';
    return {
      fontSize: 13,
      textTransform: 'uppercase',
      fontWeight: 600,
      color: map[key],
    };
  };
  labelSx = { fontSize: 13, fontWeight: 700 };
  valueSx = { fontSize: 13, textTransform: 'uppercase' };
  value2Sx = { fontSize: 13 };
  locationSx = { fontSize: 13, color: 'text.secondary' };

  renderRoute = () => {
		if (this.state.loading) {
			return <Container></Container>;
		} else {
			return (
        <Paper sx={{ width: '100%', minHeight: 'calc(100vh - 200px)', display: 'flex', flexDirection: 'column', p: 3}}>
					<Grid container >
						<Grid size={1} sx={{ pt: 1 }}>
							<RouteIcon size={'large'} />
						</Grid>
						<Grid size={9} >
              <FielderSmartNav
                variant="fullWidth"
                value={
                  this.state.showRouteInfo ? 'route'
                    : this.state.showActivity ? 'activity'
                      : 'emergencies'
                }
                onChange={(val) => {
                  if (val === 'route') {
                    this.setState(
                      { showActivity: false, showRouteInfo: true, showEmergencies: false },
                      () => { this.refresh(); }
                    );
                  } else if (val === 'activity') {
                    this.setState({ showActivity: true, showRouteInfo: false, showEmergencies: false });
                  } else {
                    this.setState({ showActivity: false, showRouteInfo: false, showEmergencies: true });
                  }
                }}
                items={[
                  { id: 'route',       label: this.props.lan.route },
                  { id: 'activity',    label: this.props.lan.activity },
                  { id: 'emergencies', label: this.props.lan.incidences },
                ]}
              />
						</Grid>
						<Grid size={2} sx={{ pt: 1 }}>
							<Grid container sx={{justifyContent: 'end', mr: 2}}>
								<Grid size={'auto'}>
                  <SmartIconButton
                    id={'close-btn'}
                    onClick={() => {
                      this.refresh();
                    }}
                  >
                    <RefreshOutlinedIcon size={'large'} />
                  </SmartIconButton>
								</Grid>
								<Grid size={'auto'}>
                  <SmartIconButton
                    id={'refresh-btn'}
                    onClick={this.props.onClose}
                  >
                    <CloseIcon size={'large'} />
                  </SmartIconButton>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
					{this.state.showRouteInfo ? (
						<Grid container >
							<Grid size={{ sm: 12, md: 12, lg: 4 }} container direction="row" sx={{ justifyContent: "center", alignItems: "center", p: 2 }}>
                <Grid size={'auto'}><CalendarMonth size={'large'} /></Grid>
                <Grid size={5} >
                  <label>
                    <DatePicker
                      selected={this.state.from}
                      onChange={this.handleFromDate}
                      minTime={this.state.minTime}
                      id='input-date-from'
                      showMonthDropdown
                      showYearDropdow
                      maxTime={new Date().setHours(23, 59)}
                      dateFormat='dd/MM/yyyy'
                      className='MyOperation-eschedule form-control mt-1 text-left'
                      placeholderText='De'
                    />
                  </label>
                </Grid>
                <Grid size={'auto'} ><CalendarMonth size={'large'} /></Grid>
                <Grid size={5} >
                  <label>
                    <DatePicker
                      selected={this.state.to}
                      onChange={this.handleToDate}
                      minTime={this.state.minTime}
                      showMonthDropdown
                      showYearDropdow
                      maxTime={new Date().setHours(23, 59)}
                      dateFormat='dd/MM/yyyy'
                      className='MyOperation-eschedule form-control mt-1 text-left'
                      placeholderText='A'
                    />
                  </label>
                </Grid>
							</Grid>
							{this.state.showTasks && (
								<Grid size={12}>
									<Typography variant={'body2'}>
										{ this.state.tasksToShow.length + ' ' + this.props.lan.tasks + ' ' +
                      this.props.lan.from + ' ' + this.state.mycount
                    }
									</Typography>
									{this.state.offset < this.state.mycount && (
										<FielderButton onClick={this.getTasks}>
											<u>{this.props.lan.showMore}</u>
										</FielderButton>
									)}
								</Grid>
							)}
              <Grid size={12} container>
                <Grid size={{ sm: 12, md: 6, lg: 3 }}>
                  <Grid container direction="row" sx={{ justifyContent: "center", alignItems: "center", mx: 1 }} spacing={2}>
                    <Grid size={12}><Typography variant={'subtitle1'}>{this.props.lan.routeNumber}</Typography></Grid>
                    <Grid size={12}><Typography variant={'h4'}>{this.state.route.id}</Typography></Grid>
                    <Grid size={12} id='route-status'>
                      <RouteStatus value={this.state.route.status} {...this.props} />
                    </Grid>
                    {this.state.route.status !== 4 &&
                      this.state.route.status !== 5 &&
                      this.state.isAllowedRouteEdit && (
                      <Grid size={12} container spacing={2} sx={{ p: 2 }}>
                        <SmartIconButton
                          id={'edit-btn'}
                          onClick={() =>
                            this.setState({ editable: !this.state.editable, add: false })
                          }
                        >
                          <SwapVert />
                        </SmartIconButton>
                        {this.state.showRouteExpenses && this.state.routeExpensesPreferences && (
                          <SmartIconButton
                            id={'config-expense-btn'}
                            onClick={() =>
                              this.setState({ configExpenses: !this.state.configExpenses })
                            }
                          >
                            <AccountBalanceWallet />
                          </SmartIconButton>
                        )}
                      </Grid>
                    )}
                  </Grid>
                  {this.state.editable && (
                    <Grid container>
                      {this.state.isAllowedRouteAddTask && (
                        <motion.div
                          initial={{ x: -200, opacity: 0 }}
                          animate={{ x: 0, opacity: 1 }}
                          transition={{ duration: 0.5 }}
                        >
                          <TextField
                            id="route-details-search"
                            variant="outlined"
                            placeholder={
                              `${this.props.lan.searchBy} ID ${this.props.lan.and} ${this.props.lan.folio}`
                            }
                            value={this.state.idTask || ''}
                            onChange={this.onIdTaskChange}
                            onKeyPress={this.handleKeyPress}
                            fullWidth
                            size="small"
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <SearchIcon color="action" />
                                </InputAdornment>
                              ),
                              sx: {
                                borderRadius: 2,
                                bgcolor: (theme) => theme.palette.background.paper,
                              },
                            }}
                          />
                        </motion.div>
                      )}
                      {this.state.editable && this.state.add && (
                        <Grid size={12}>
                          <Typography variant={'caption'}>{this.props.lan.label_position_add_task}</Typography>
                          <select
                            onChange={this.onChangeTaskPosition}
                            value={this.state.position}
                          >
                            {this.getTaskNumberSelect()}
                          </select>
                        </Grid>
                      )}
                    </Grid>
                  )}
                  <Grid container sx={{ mx: 1, mt: 3 }} spacing={2}>
                    <TextField
                      size="small"
                      label={this.props.lan.routeStartPointTitle}
                      value={this.state.startLocation.address}
                      disabled
                      fullWidth
                    />
                    {this.state.route.status !== 3 && this.state.route.status !== 4 &&
                      this.state.route.status !== 5 && this.state.isAllowedRouteEdit && this.state.editable && (
                        <Grid size={12}>
                          <img src={editImageIcon} alt='' onClick={() => {
                            this.setState({ showEditRouteStartPoint: !this.state.showEditRouteStartPoint });
                          }} />
                        </Grid>
                      )}
                    <TextField
                      size="small"
                      label={this.props.lan.routeEndPointTitle}
                      value={this.state.endLocation ? this.state.endLocation.address : null}
                      disabled
                      fullWidth
                    />
                    {this.state.route.status !== 4 &&
                      this.state.route.status !== 5 &&
                      this.state.isAllowedRouteEdit &&
                      this.state.editable && (
                        <Grid szie={12}>
                          <img
                            src={editImageIcon}
                            alt=''
                            onClick={() => {
                              this.setState({
                                showEditRouteEndPoint: !this.state.showEditRouteEndPoint,
                              });
                            }}
                          />
                        </Grid>
                      )}
                    <TextField
                      size="small"
                      label={this.props.lan.routeName}
                      value={this.state.route.name}
                      disabled
                      fullWidth
                    />
                    {this.state.route.agent && (
                      <Grid size={12} container>
                        <Grid size={11}>
                          <TextField
                            size="small"
                            label={this.props.lan.agentName}
                            value={this.state.route.agent.name + ' ' + this.state.route.agent.lastName}
                            disabled
                            fullWidth
                          />
                        </Grid>
                        <Grid size={1}>
                          <img
                            src={DetailTaskIcon}
                            alt='Change Position'
                            style={{ width: '8%', marginLeft: '2%' }}
                            onClick={() => this.showDetailAgent(
                              this.state.route.agent.idAgent)}
                          />
                        </Grid>
                      </Grid>
                    )}
                    {!this.state.route.agent && (
                      <TextField
                        size="small"
                        label={this.props.lan.agentName}
                        value={this.props.lan.unassigned}
                        disabled
                        fullWidth
                      />
                    )}
                    <TextField
                      size="small"
                      label={this.props.lan.executionDate}
                      value={this.state.route.executionFormattedDate}
                      disabled
                      fullWidth
                    />
                    {this.state.route.startedFormattedDate && (
                      <TextField
                        size="small"
                        label={this.props.lan.startedFormattedDate}
                        value={this.state.route.startedFormattedDate}
                        disabled
                        fullWidth
                      />
                    )}
                    {this.state.route.finishedFormattedDate && (
                      <TextField
                        size="small"
                        label={this.props.lan.finishedFormattedDate}
                        value={this.state.route.finishedFormattedDate}
                        disabled
                        fullWidth
                      />
                    )}
                    <TextField
                      size="small"
                      label={this.props.lan.timeTraveled}
                      value={this.state.route.estimatedTimeValue}
                      disabled
                      fullWidth
                    />
                    <TextField
                      size="small"
                      label={this.props.lan.distanceTraveled}
                      value={this.state.km}
                      disabled
                      fullWidth
                    />
                    <TextField
                      size="small"
                      label={this.props.lan.routeCost + ' (km) '}
                      value={this.state.kmRouteCost}
                      disabled
                      fullWidth
                    />
                    {this.state.route.comment && this.state.route.status === 4 && (
                      <TextField
                        size="small"
                        label={this.props.lan.cancelReason}
                        value={this.state.route.comment}
                        disabled
                        fullWidth
                      />
                    )}
                    {this.state.route.expenses &&
                      this.state.route.expenses.defaultExpenses &&
                      this.state.route.expenses.defaultExpenses.map((element, index) => {
                        if (element.enabled) {
                          return (
                            <TextField
                              size="small"
                              label={element.name === 'expensesFood'
                                ? this.props.lan.expensesFood
                                : element.name === 'expensesSleeping'
                                  ? this.props.lan.expensesSleeping
                                  : element.name === 'expensesKm'
                                    ? this.props.lan.expensesKm
                                    : element.name}
                              value={element.name === 'expensesKm' ? '% ' + element.value : '$ ' + element.value}
                              disabled
                              fullWidth
                            />
                          );
                        }
                      })}
                    {this.state.route.expenses &&
                      this.state.route.expenses.dynamicExpenses &&
                      this.state.route.expenses.dynamicExpenses.map((element, index) => {
                        if (element.enabled) {
                          return (
                            <TextField
                              size="small"
                              label={element.name}
                              value={'$ ' + element.value}
                              disabled
                              fullWidth
                            />
                          );
                        }
                      })}
                  </Grid>
                </Grid>
                <Grid size={{ sm: 12, md: 6, lg: 5 }} container>
                  <Grid size={12} container sx={{ mt: 3 }} >
                    <DragDropContext onDragEnd={this.onDragEnd}>
                      <Scrollbars style={{ height: '100%' }}>
                        <Droppable droppableId="droppable">
                          {(provided, snapshot) => (
                            <Box
                              {...provided.droppableProps}
                              ref={provided.innerRef}
                              sx={this.getListSx(snapshot.isDraggingOver)}
                            >
                              {this.state.items.map((element, i) => (
                                <Draggable
                                  key={`${element.idTask}-task-draggable`}
                                  draggableId={`${element.idTask}-task-draggable`}
                                  index={i}
                                  isDragDisabled={!this.state.isAllowedReorganizeRoute}
                                >
                                  {(provided, snapshot) => {
                                    let taskType = '';
                                    if (this.state.taskTypes.taskTypeFunctionality) {
                                      const parents = getTaskTypeParents(
                                        element.serviceTypeId,
                                        this.state.taskTypes.types
                                      );
                                      taskType = parents.join(' > ');
                                    } else {
                                      switch (element.serviceTypeId) {
                                        case 1: taskType = this.props.lan.tasktype1; break;
                                        case 2: taskType = this.props.lan.tasktype2; break;
                                        case 3: taskType = this.props.lan.tasktype3; break;
                                        case 4: taskType = this.props.lan.tasktype4; break;
                                        default: taskType = '';
                                      }
                                    }

                                    return (
                                      <Grid container spacing={0.5} alignItems="stretch">
                                        <Grid size={10} ref={provided.innerRef}{...provided.dragHandleProps}{...provided.draggableProps}>
                                          <Box sx={this.getItemSx(snapshot.isDragging)}>
                                            {/* Row: ID Fielder + value + Status */}
                                            <Grid container alignItems="center" spacing={1}>
                                              <Grid size="auto">
                                                <Typography sx={this.labelSx}>
                                                  {this.props.lan.idFielder}
                                                </Typography>
                                              </Grid>
                                              <Grid size="auto">
                                                <Typography id={`task-idFielder-${i}`} sx={this.valueSx}>
                                                  {element.idTask}
                                                </Typography>
                                              </Grid>
                                              <Grid size>
                                                <Box sx={{ ml: 1 }}>
                                                  <StatusFormatter {...this.props} value={element.status} />
                                                </Box>
                                              </Grid>
                                            </Grid>
                                            {/* Row: Custom ID */}
                                            <Grid container alignItems="center" spacing={1} sx={{ mt: 0.5 }}>
                                              <Grid size="auto">
                                                <Typography sx={this.labelSx}>
                                                  {this.props.lan.idCustom}
                                                </Typography>
                                              </Grid>
                                              <Grid size="auto">
                                                <Typography id={`task-idCustom-${i}`} sx={this.value2Sx}>
                                                  {element.idCustom}
                                                </Typography>
                                              </Grid>
                                            </Grid>
                                            {/* Row: Folio */}
                                            <Grid container alignItems="center" spacing={1} sx={{ mt: 0.5 }}>
                                              <Grid size="auto">
                                                <Typography sx={this.labelSx}>
                                                  {this.props.lan.folio}
                                                </Typography>
                                              </Grid>
                                              <Grid size="auto">
                                                <Typography id={`task-folio-${i}`} sx={this.value2Sx}>
                                                  {element.folio ? element.folio : this.props.lan.noFolio}
                                                </Typography>
                                              </Grid>
                                            </Grid>
                                            {/* Row: Priority + badges */}
                                            <Grid container alignItems="center" spacing={1} sx={{ mt: 0.5 }}>
                                              <Grid size="auto">
                                                <Typography sx={this.labelSx}>
                                                  {this.props.lan.priority}
                                                </Typography>
                                              </Grid>
                                              <Grid size="auto">
                                                <Typography
                                                  id={`task-severity-${i}`}
                                                  sx={this.getSeveritySx(element.severity)}
                                                >
                                                  {getSeverityText(
                                                    element.severity,
                                                    this.props.lan,
                                                    element.severityName
                                                  )}
                                                </Typography>
                                              </Grid>
                                              <Grid size="auto">
                                                <Grid container alignItems="center" spacing={1}>
                                                  {element.countAssets > 0 && (
                                                    <Grid size="auto">
                                                      <Box component="img" src={AssetsIcon} alt="" sx={{ height: 18, mb: 0.25 }} />
                                                    </Grid>
                                                  )}
                                                  {element.countInventories > 0 && (
                                                    <Grid size="auto">
                                                      <Box component="img" src={InventoryIcon} alt="" sx={{ height: 18, mb: 0.25 }} />
                                                    </Grid>
                                                  )}
                                                  {element.countImages > 0 && (
                                                    <Grid size="auto">
                                                      <Box component="img" src={ImagesIcon} alt="" sx={{ height: 18, mb: 0.25 }} />
                                                    </Grid>
                                                  )}
                                                  {element.countForms > 0 && (
                                                    <Grid size="auto">
                                                      <Box component="img" src={FormIcon} alt="" sx={{ height: 18, mb: 0.25 }} />
                                                    </Grid>
                                                  )}
                                                </Grid>
                                              </Grid>
                                            </Grid>
                                            {/* Row: Task type + Show detail */}
                                            <Grid container alignItems="center" spacing={1} sx={{ mt: 1 }}>
                                              <Grid size={6}>
                                                <Typography id={`task-type-${i}`} sx={{ fontSize: 13, textTransform: 'capitalize' }}>
                                                  {taskType}
                                                </Typography>
                                              </Grid>
                                              <Grid size={6} display="flex" justifyContent="flex-end">
                                                <Button
                                                  variant="outlined"
                                                  size="small"
                                                  onClick={() => this.showDetailTaskDetail(element.idTask)}
                                                  sx={{
                                                    borderRadius: 2,
                                                    textTransform: 'none',
                                                    fontSize: 13,
                                                    px: 1.5,
                                                  }}
                                                >
                                                  {this.props.lan.showDetail}
                                                </Button>
                                              </Grid>
                                            </Grid>
                                            {/* Row: Start time */}
                                            <Grid container alignItems="center" sx={{ mt: 0.5 }}>
                                              <Grid size={12}>
                                                <Typography id={`task-executeTime-${i}`} sx={this.labelSx}>
                                                  {element.startTimeFormatted}
                                                </Typography>
                                              </Grid>
                                            </Grid>
                                            {/* Row: Client (optional) */}
                                            {element.user && (
                                              <Grid container alignItems="center" spacing={1} sx={{ mt: 1.5 }}>
                                                <Grid size="auto">
                                                  <Typography sx={this.labelSx}>{this.props.lan.client}</Typography>
                                                </Grid>
                                                <Grid size="auto">
                                                  <Typography id={`task-iduser-${i}`} sx={this.value2Sx}>
                                                    {`${element.user.name} ${element.user.lastName}`}
                                                  </Typography>
                                                </Grid>
                                              </Grid>
                                            )}
                                            {/* Row: Branch (optional) */}
                                            {element.branch && (
                                              <Grid container alignItems="center" spacing={1} sx={{ mt: 1.5 }}>
                                                <Grid size="auto">
                                                  <Typography sx={this.labelSx}>{this.props.lan.branch}</Typography>
                                                </Grid>
                                                <Grid size="auto">
                                                  <Typography id={`task-idBranch-${i}`} sx={this.value2Sx}>
                                                    {(element.branch.idCustom ? `${element.branch.idCustom} ` : '') + element.branch.name}
                                                  </Typography>
                                                </Grid>
                                              </Grid>
                                            )}
                                            {/* Row: Address */}
                                            <Grid container sx={{ mt: 0.5 }}>
                                              <Grid size={12}>
                                                <Typography id={`task-address-${i}`} sx={this.locationSx}>
                                                  {element.startLocation.address}
                                                </Typography>
                                              </Grid>
                                            </Grid>
                                            {/* Row: Original dates label */}
                                            <Grid container sx={{ mt: 1.5 }}>
                                              <Grid size="auto">
                                                <Typography sx={this.labelSx}>{this.props.lan.originalDates}</Typography>
                                              </Grid>
                                            </Grid>
                                            {/* Row: Started/Finished labels */}
                                            <Grid container alignItems="center" sx={{ mt: 0.5 }}>
                                              <Grid size>
                                                <Typography sx={this.labelSx}>{this.props.lan.startedFormattedDate}</Typography>
                                              </Grid>
                                              <Grid size>
                                                <Typography sx={this.labelSx}>{this.props.lan.finishedFormattedDate}</Typography>
                                              </Grid>
                                            </Grid>
                                            {/* Row: Started/Finished values */}
                                            <Grid container alignItems="center">
                                              <Grid size>
                                                <Typography id={`task-startDate-${i}`} sx={this.value2Sx}>
                                                  {element.startDateTimeRange ? this.formatDate(element.startDateTimeRange) : 'No date'}
                                                </Typography>
                                              </Grid>
                                              <Grid size>
                                                <Typography id={`task-finishDate-${i}`} sx={this.value2Sx}>
                                                  {element.endDateTimeRange ? this.formatDate(element.endDateTimeRange) : 'No date'}
                                                </Typography>
                                              </Grid>
                                            </Grid>
                                          </Box>
                                        </Grid>
                                        {/* Right-side action icons (only in editable mode) */}
                                        {this.state.editable && (
                                          <Grid size="auto" display="flex" flexDirection="column" justifyContent="center" alignItems="center" sx={{ ml: 1 }}>
                                            {this.state.isAllowedReorganizeRoute && (
                                              <Box component="img" src={RepositionSmallIcon} alt="" sx={{ my: 0.5, width: 18, height: 18 }} />
                                            )}
                                            {this.state.isAllowedDeleteTask && (
                                              <Box
                                                component="img"
                                                src={DeleteIcon}
                                                alt=""
                                                sx={{ my: 0.5, width: 18, height: 18, cursor: 'pointer' }}
                                                onClick={() => this.deleteTaskFromRoute(i)}
                                              />
                                            )}
                                          </Grid>
                                        )}
                                      </Grid>
                                    );
                                  }}
                                </Draggable>
                              ))}
                              {provided.placeholder}
                            </Box>
                          )}
                        </Droppable>
                      </Scrollbars>
                    </DragDropContext>

                  </Grid>
                </Grid>
                <Grid size={{ sm: 12, md: 12, lg: 4 }} container>
                  <Grid size={12}>
                    <Map
                      googleMapURL={GOOGLE_URL_WITH_LIBRARIES}
                      loadingElement={<div style={{ height: `100%` }} />}
                      containerElement={<div style={{ height: `100%` }} />}
                      mapElement={<div style={{ height: `100%` }} />}
                      center={{ lat: 19.3901284, lng: -99.2896576 }}
                      zoom={15}
                      markersData={this.state.markers}
                      routePoints={this.state.routePoints}
                      origin={this.state.origin}
                      changeMap={this.state.initialMap}
                      onChangeInitialMap={this.onChangeInitialMap}
                    />
                  </Grid>
                  <Grid size={12}>
                    {this.state.editable && (
                      <FielderButton onClick={this.updateTaskOrders}>
                        {this.props.lan.save}
                      </FielderButton>
                    )}
                  </Grid>
                </Grid>
              </Grid>
						</Grid>
					) : null}
					{this.state.showActivity && (
            <TableContainer component={Paper} variant="outlined" sx={{ borderRadius: 2 }}>
              <Table size="small" aria-label="route-activity-log">
                <TableBody>
                  {this.state.route.logs &&
                    this.state.route.logs.map((element, i) => (
                      <TableRow key={i} sx={activityRowSx}>
                        <TableCell align="left" sx={activityCellSx}>
                          <Box component="img"
                               src={ClockIcon}
                               alt=""
                               sx={{ width: 16, height: 16, mr: 1.5, ml: 3, verticalAlign: 'middle' }}
                          />
                          <Box component="span" sx={{ verticalAlign: 'middle' }}>
                            {this.getActivityTime(element.createdDate)}
                          </Box>
                        </TableCell>

                        <TableCell align="left" sx={activityCellSx}>
                          {this.getActivityDate(element.createdDate)}
                        </TableCell>

                        <TableCell align="left" sx={activityCellSx}>
                          {this.props.lan[LOC_ACTIVITY_TYPE + element.type]}
                        </TableCell>

                        {this.getActivityUser(element)}
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
					)}
					{this.state.showEmergencies && (
						<Grid container direction="row" sx={{ justifyContent: "center", alignItems: "center" }}>
							<Typography variant={'subtitle1'}>{this.props.lan.incidenceAgent}</Typography>
							{this.state.route.emergencies &&
								this.state.route.emergencies.map((element, i) => (
									<Grid size={12} id={i}>
										<Typography variant={'body1'}>{this.props.lan.incidenceCount + '' + (parseInt(i) + 1)}</Typography>
										<Typography variant={'body2'}>{this.getEmergencyDate(element)}</Typography>
										<Typography variant={'body2'}>{element.emergencyText}</Typography>
									</Grid>
								))}
						</Grid>
					)}
				</Paper>
			);
		}
	};
	editAgentModal = () => {
		this.props.fielderModal.setContent(null);
		this.props.fielderModal.closeModal(POP_EDIT_AGENT);
		const dynamicContent = (
			<AgentDetail
				{...this.props}
				showAction={() => {
					this.closeRenderModal();
				}}
				dataAgent={this.state.dataAgent}
				idAgent={this.state.idAgent}
			/>
		);
		this.props.fielderModal.setContent(POP_EDIT_AGENT, dynamicContent);
		this.props.fielderModal.openModal(POP_EDIT_AGENT);
	};
	renderAgentModal = (showModal, titleKey, id, fullWidth = false) => {
		if (!showModal) return null;
		return (
			<Modal
				id={id}
				title={this.props.lan[titleKey]}
				icon={<AddAgentIcon sx={{ color: DeepSpaceGrey, width: '24px' }} />}
				fullWidth={fullWidth}
			/>
		);
	};
	closeRenderModal = () => {
		this.setState({
			showDetailAgent: false
		}, () => {
			this.props.fielderModal.closeAllModals();
		});
	};
	render() {
		return (
			<>
				{this.renderAgentModal(this.state.showDetailAgent, 'detailAgentTitle', POP_EDIT_AGENT, true)}
				{this.state.errorMessage && (
					<ErrorMessage{...this.props} closeErrorMessage={() => this.closePopup()} message={this.state.message} showErrorMessage={this.state.errorMessage} icon={this.state.icon} />
				)}
					{this.state.showDetailTask && (
						<TaskDetails
							{...this.props}
							onClose={() => {
								this.setState({ showDetailTask: false, idTask: null });
							}}
							onCloseModal={(res, res1) => this.closeEditTaskPopup(res, res1)}
							idTasks={[this.state.idTask]}
							canNotEdit={true}
						/>
					)}
					{this.state.showTasksResult && (
						<TaskSearchResultsPopup
							{...this.props}
							showPopup={true}
							search={this.state.idTask}
							setDefaultFalse={() => this.setDefaultFalse()}
							setDefaultFalseModal={(task, position) => this.setDefaultFalseModal(task, position)}
							sourceItems={this.state.items}
						/>
					)}
					{this.state.showEditRouteEndPoint && (
						<EditRouteEndPoint
							{...this.props}
							endPoint={this.state.endLocation}
							onClose={() => {
								this.setState({ showEditRouteEndPoint: false });
							}}
							onSaveEndPoint={(endPoint) => {
								this.setState({ endLocation: endPoint, showEditRouteEndPoint: false });
							}}
						/>
					)}
					{this.state.showEditRouteStartPoint && (
						<EditRouteEndPoint
							{...this.props}
							endPoint={this.state.startLocation}
							onClose={() => {
								this.setState({ showEditRouteStartPoint: false });
							}}
							onSaveEndPoint={(startPoint) => {
								this.setState({ startLocation: startPoint, showEditRouteStartPoint: false });
							}}
						/>
					)}
					{this.state.configExpenses && (
						<EditExpenses
							{...this.props}
							route={this.state.route}
							onClose={() => {
								this.setState({ configExpenses: false });
								this.refresh();
							}}
						/>
					)}
					<this.renderRoute />
			</>
		);
	};
}
const mapStateToProps = (state) => ({
	session: state.utils.session,
});
export default connect(mapStateToProps)(withSnackbar(RouteDetails));
export function withSnackbar(Component) {
    return function WrappedComponent(props) {
        const fielderMsg = useFielderSnackBar();
        return <Component {...props} fielderMsg={fielderMsg} />;
    }
}
//Original code:
/*import React, { Component } from 'react';
import { AddAgentIcon, DeepSpaceGrey } from '@core/theme/baseTheme';
import CalendarIcon from '@assets/icons/calendar-icon.svg';
import cancelIcon from '@assets/icons/cancel.svg';
import RepositionIcon from '@assets/icons/changeOrder.png';
import ClockIcon from '@assets/icons/clock-icon.svg';
import ProfileImage from '@assets/icons/default-profile-icon.svg';
import DeleteIcon from '@assets/icons/delete-icon.svg';
import DetailTaskIcon from '@assets/icons/detalle-task-icon.svg';
import DropDown from '@assets/icons/dropdown.svg';
import editImageIcon from '@assets/icons/edit-icon.svg';
import ExpensesIcon from '@assets/icons/expenses.png';
import RefreshIcon from '@assets/icons/refresh-icon.svg';
import RepositionSmallIcon from '@assets/icons/reposition-icon.svg';
import SearchIcon from '@assets/icons/search-icon.svg';
import AssetsIcon from '@assets/icons/taskGroup-assets-icon.svg';
import FormIcon from '@assets/icons/taskGroup-form-icon.svg';
import ImagesIcon from '@assets/icons/taskGroup-image-icon.svg';
import InventoryIcon from '@assets/icons/taskGroup-inventory-icon.svg';
import RoutesImage from '@assets/images/routesimage.svg';
import { Table, TableBody, TableCell, TableRow } from '@mui/material';
import { getAccountPreferences } from 'FielderUtils/accountUtils';
import ErrorCodes from 'FielderUtils/ErrorCodes';
import routeConst from 'FielderUtils/roleManagementConst/routeConst';
import { GOOGLE_URL_WITH_LIBRARIES } from 'FielderUtils/session/Session';
import { getStatus } from 'FielderUtils/status/statusmapper';
import TaskStatusConst from 'FielderUtils/status/taskStatus';
import { getPinColor } from 'FielderUtils/task/pinColor';
import { getSeverityText, getSeverityClassName } from 'FielderUtils/task/taskSeverity';
import {
	listToTree,
	getAllTaskTypeList,
	hasTaskTypeDynamoTable,
	getTaskTypeParents,
} from 'FielderUtils/taskType/taskType';
import { Droppable, DragDropContext, Draggable } from '@hello-pangea/dnd';
import { Scrollbars } from 'react-custom-scrollbars';
import DatePicker from 'react-datepicker';
import { connect } from 'react-redux';
import LightSpeed from 'react-reveal/LightSpeed';
import { isRoleValid } from '../../core/utils/roles/validateRoles';
import AgentDetail from '../Agents/AgentDetailContainer';
import ErrorMessage from 'OldComponents/ErrorMessage/ErrorMessage';
import Map from '../Map';
import StatusFormatter from '../SmartTable/StatusFormatter';
import RouteStatus from '../Status/RouteStatus';
import TaskDetails from '../TaskDetails';
import EditExpenses from './EditExpenses';
import EditRouteEndPoint from './EditRouteEndPoint';
import TaskSearchResultsPopup from './TaskSearchResultPopup';
import './RouteDetails.css';
import { doActionReorderRouteRequest, getRouteByIdRequest, getRouteTaskToShowRequest, getRouteTaskFolioRequest } from '@core/api/route/route.service';
import { reorderArrayElementByIndex } from '@core/utils/array/reorder.utils';
import { useFielderSnackBar } from '~/FielderElements/useFielderSnackBar';
import Modal from '~/FielderElements/Modal';
import { FIELDER } from '@core/constants/base.constants';

const { pop: POP_ID } = FIELDER.idElement;
const POP_EDIT_AGENT = POP_ID.routeDetail.replace('{0}', 'editAgentModal');
var Request = require('FielderRequestTypes');
const LOC_ACTIVITY_TYPE = 'activity_type_';
var moment = require('moment-timezone');
class RouteDetails extends Component {
  constructor(props) {
    super(props);
    this.editAgentModal = this.editAgentModal.bind(this);
    this.onChangeInitialMap = this.onChangeInitialMap.bind(this);
    this.state = {
      routeDetailsInfo: true,
      route: {},
      items: [],
      markers: [],
      originalMarkers: [],
      originalItems: [],
      routePoints: [],
      editable: false,
      add: false,
      loading: true,
      showActivity: false,
      position: 0,
      showRouteInfo: true,
      showEmergencies: false,
      from: null,
      to: null,
      opacity: 1,
      tasksToShow: [],
      showTasks: false,
      showDetailTask: false,
      idTask: null,
      errorMessage: false,
      limit: 50,
      offset: 0,
      mycount: 0,
      initialMap: true,
      origin: 'routeDetail',
      taskTypes: {
        taskTypeFunctionality: false,
        types: [],
      },
      kmCost: 'hola',
      startLocation: {},
      endLocation: {},
      configExpenses: false,

      isAllowedRouteEdit: false,
      isAllowedRouteAddTask: false,
      isAllowedReorganizeRoute: false,
      isAllowedDeleteTask: false,
    };
  }
  componentDidMount = () => {
    getAccountPreferences(this, this.props.session);

    let state = this.state;
    state.isAllowedRouteEdit = isRoleValid(
      routeConst.ROUTES,
      routeConst.EDIT,
      this.props.session.roles
    );

    state.isAllowedRouteAddTask = isRoleValid(
      routeConst.ROUTES,
      routeConst.ADD_TASK_BY_FOLIO,
      this.props.session.roles
    );

    state.isAllowedReorganizeRoute = isRoleValid(
      routeConst.ROUTES,
      routeConst.REORGANIZE_ROUTE,
      this.props.session.roles
    );

    state.isAllowedDeleteTask = isRoleValid(
      routeConst.ROUTES,
      routeConst.DELETE_TASK_FROM_ROUTE,
      this.props.session.roles
    );

    this.setState(state);

    hasTaskTypeDynamoTable().then((taskTypeFunctionality) => {
      if (taskTypeFunctionality) {
        getAllTaskTypeList(
          (formatTypes, taskTypes) => {
            let types = listToTree(formatTypes);

            let state = this.state;
            state.taskTypes.types = types;
            state.taskTypes.taskTypeFunctionality = taskTypeFunctionality;
            this.setState(state);
          },
          this.props,
          true
        );
      }
    });

    const onSuccess = (response) => {
      this.renderRouteResponse(response);
    }

    const loadingConfig = { dispatch: this.props.dispatch }
    getRouteByIdRequest(Request.getRouteById(this.props.idRoute), onSuccess, null, loadingConfig);

  };

  getListStyle = (isDraggingOver) => ({
    background: 'white',
    padding: 8,
    height: '100%',
    width: '100%',
  });
  getItemStyle = (isDragging, draggableStyle) => ({
    userSelect: 'none',
    MozUserSelect: 'none',

    padding: 16,
    margin: `0 0 8px 0`,

    background: isDragging ? '#4a4a4a4a' : 'white',
    ...draggableStyle,
  });
  reorder(list, startIndex, endIndex) {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  }
  onDragEnd = (e) => {
    if (!e.destination || e.source.index === e.destination.index) return;
    const items = reorderArrayElementByIndex(this.state.items, e.source.index, e.destination.index);
    this.setState({ items });
  }
  onChangeTaskPosition = (event) => {
    this.setState({ position: event.target.value });
  };
  renderReorderRoute = (res) => {
    const routeResponse = res;
    if (routeResponse.success) {
      this.setState({
        route: routeResponse.route,
        items: routeResponse.route.tasks,
        editable: false,
      });

      this.getMarkers();
    }
  };
  canUpdateRoute = (tasks) => {
    let canUpdateRoute = true;
    let prevStatus, currentStatus;
    if (tasks.length != 0) {
      prevStatus = tasks[0].status;

      for (let index = 0; index < tasks.length; index++) {
        currentStatus = tasks[index].status;
        if (
          (prevStatus == TaskStatusConst.MANAGING ||
            prevStatus == TaskStatusConst.WAITING_FOR_AGENT ||
            prevStatus == TaskStatusConst.IN_PROGRESS) &&
          (currentStatus == TaskStatusConst.FINISH ||
            currentStatus == TaskStatusConst.EXECUTING ||
            currentStatus == TaskStatusConst.START_ROUTE ||
            currentStatus == TaskStatusConst.ARRIVED)
        ) {
          canUpdateRoute = false;
          break;
        }
        prevStatus = tasks[index].status;
      }
    } else {
      canUpdateRoute = false;
    }
    return canUpdateRoute;
  };
  updateTaskOrders = () => {
    const route = this.state.route;
    route.tasks = this.state.items;

    if (this.canUpdateRoute(route.tasks)) {
      route.endPoint = this.state.endLocation;
      route.startPoint = this.state.startLocation;

      let body = Request.getOrderRoute(route);

      const onSuccess = (response) => {
        this.renderReorderRoute(response);
        this.props.fielderMsg({message: this.props.lan.savedCorrectly, variant: 'success', closeButton: true, duration: 5000});
      }

      const onError = (response) => {
        if (response.errorCode == ErrorCodes.ROUTE_MODIFIED_BY_AGENT) {
          this.props.fielderMsg({message: this.props.lan.routeChangedByAgent, variant:  'warning', closeButton: true, duration: 6000});
          this.refresh();
        } else {
          this.props.fielderMsg({message: this.props.lan.unexpectedErrorOcurred, variant: 'error', closeButton: true, duration: 5000});
        }
      }

      const loadingConfig = { dispatch: this.props.dispatch }
      doActionReorderRouteRequest(body, onSuccess, onError, loadingConfig);

    } else {
      this.props.fielderMsg({message: this.props.lan.messageUpdateRoute, variant:  'warning', closeButton: true, duration: 6000});
    }
  };
  showDetailTask = (id) => {
    if (id && id > 0) {
      this.setState({ showDetailTask: true, idTask: id });
    }
  };
  showDetailTaskDetail = (id) => {
    if (id && id > 0) {
      this.setState({ showDetailTask: true, idTask: id });
    }
  };
  getMarkerDescription = (task, position) => {
    let description = '';
    const priority = task?.severity ? task.severity : task.priority;
    const priorityName = task?.severityName ? task.severityName : task.priorityName;

    if (position) {
      description = description + ' ( ' + position + ' ) ';
    }
    let taskFolio = task.folio ? task.folio : '';
    if (task.idTask) {
      description = description + '\n- ' + this.props.lan.task + ': ' + task.idTask + ' [' + taskFolio + ']';
    }
    if (task.severity) {
      description = description + '\n- ' + this.props.lan.priority + ': ' + getSeverityText(priority, this.props.lan, priorityName);
    }
    if (task.branch) {
      description = description + '\n- '+ this.props.lan.branch + ': ' + task.branch.name;
    } else if (task.user && task.user.branch) {
      description = description + '\n- '+ this.props.lan.branch + ': ' + + task.user.branch.name;
    } else if (task.user) {
      description = description + '\n- '+ this.props.lan.client + ': ' + + task.user.name;
    }

    return description;
  };
  setDefaultTasksMarkers() {
    const markers = [];
    const routePoints = [];
    const component = this;

    this.state.items.forEach(function (element, index) {
      const loc = element.startLocation;
      let color = getPinColor([element], 0);
      const position = index + 1;
      markers.push({
        coordinates: { lat: parseFloat(loc.latitude), lng: parseFloat(loc.longitud) },
        pin: color,
        draggable: false,
        id: element.idTask,
        onMarkerClick: (id) => component.showDetailTask(id),
        description: component.getMarkerDescription(element, position),
      });
      routePoints.push({
        coordinates: { lat: parseFloat(loc.latitude), lng: parseFloat(loc.longitud) },
        pin: color,
        draggable: false,
      });
    });

    var latitude = '18.4316459';
    var longi = '-100.2870970';
    for (let i = 0; i < this.state.route.emergencies.length; i++) {
      let color = 'yellow';

      markers.push({
        coordinates: {
          lat: parseFloat(this.state.route.emergencies[i].latitude),
          lng: parseFloat(this.state.route.emergencies[i].longitude),
        },
        pin: color,
        draggable: false,
        description: this.state.route.emergencies[i].emergencyText
          ? this.state.route.emergencies[i].emergencyText
          : '',
      });
    }

    this.setState({ markers: markers, routePoints: routePoints });
  };
  getAgentMarkerDescription = (agent) => {
    let description = '';
    if (agent) {
      const name = agent.name ? agent.name : '';
      const lname = agent.lastName ? agent.lastName : '';
      const agentCompanyName = agent.companyName ? agent.companyName : '';
      description = '- '+name + ' ' + lname+ '\n- '+ this.props.lan.company+': '+agentCompanyName;
      return description;
    }
    return description;
  };
  showDetailAgent = (id) => {
    if (id && id > 0) {
      this.setState({
        showDetailAgent: true,
        idAgent: id
      }, () => {
        this.editAgentModal();
      });
    }
  };
  getEndPoint = () => {
    if (this.state.route && this.state.route.endPoint) {
      var endPoint = this.state.route.endPoint;
      var pin = 'end-route';
      var endPointLocation = {
        coordinates: { lat: parseFloat(endPoint.latitude), lng: parseFloat(endPoint.longitud) },
        pin: pin,
        draggable: false,
        id: endPoint.idLocation,
        description: this.props.lan.routeEndPoint,
      };
      return endPointLocation;
    }
    return null;
  };
  getMarkers = () => {
    const markers = [];
    const routePoints = [];
    const component = this;
    var agentLocation = null;
    if (
      this.state.route &&
      this.state.route.agent &&
      (this.state.route.agent.geolocation || this.state.route.agent.location)
    ) {
      var loc = null;
      if (this.state.route.status === 3 && this.state.route.agent.geolocation) {
        loc = this.state.route.agent.geolocation;
      } else if (this.state.route.agent.location) {
        loc = this.state.route.agent.location;
      }

      if (loc != null) {
        const agent = this.state.route.agent;

        if (loc.activeIcon == true) {
          var pin = 'agent';
        } else {
          var pin = 'inactiveAgent';
        }
        agentLocation = {
          coordinates: { lat: parseFloat(loc.latitude), lng: parseFloat(loc.longitud) },
          pin: pin,
          draggable: false,
          id: agent.idAgent,
          onMarkerClick: (id) => this.showDetailAgent(id),
          description: this.getAgentMarkerDescription(agent),
        };
        markers.push(agentLocation);
      }
    }

    if (agentLocation != null) {
      var coords = agentLocation.coordinates;
      routePoints.push({
        coordinates: coords,
        pin: 'agentroute',
        draggable: false,
      });
    }

    this.state.items.forEach(function (element, index) {
      const loc = element.startLocation;

      let color = getPinColor([element], 0);
      const position = index + 1;
      let latitude = parseFloat(loc.latitude);
      let longitud = parseFloat(loc.longitud);
      markers.push({
        coordinates: { lat: latitude, lng: longitud },
        pin: color,
        draggable: false,
        id: element.idTask,
        onMarkerClick: (id) => component.showDetailTask(id),
        description: component.getMarkerDescription(element, position),
      });

      routePoints.push({
        coordinates: { lat: latitude, lng: longitud },
        pin: color,
        draggable: false,
      });
    });

    this.state.tasksToShow.forEach(function (element, index) {
      const loc = element.startLocation;
      let color = getPinColor([element], 0);
      markers.push({
        coordinates: { lat: parseFloat(loc.latitude), lng: parseFloat(loc.longitud) },
        pin: color,
        draggable: false,
        id: element.idTask,
        onMarkerClick: (id) => component.showDetailTask(id),
        description: component.getMarkerDescription(element),
      });
    });

    var endPointLocation = this.getEndPoint();
    if (endPointLocation) {
      routePoints.push({
        coordinates: endPointLocation.coordinates,
        pin: 'agentroute',
        draggable: false,
      });
      markers.push(endPointLocation);
    }

    var latitude = '18.4316459';
    var longi = '-100.2870970';
    for (let i = 0; i < this.state.route.emergencies.length; i++) {
      let tz = this.state.timeZone;
      let ft = 'DD-MM-YYYY hh:mm a';

      let color = 'yellow';

      markers.push({
        coordinates: {
          lat: parseFloat(this.state.route.emergencies[i].latitude),
          lng: parseFloat(this.state.route.emergencies[i].longitude),
        },
        pin: color,
        draggable: false,
        description: this.state.route.emergencies[i].emergencyText
          ? this.state.route.emergencies[i].emergencyText +
          '  ' +
          moment.tz(this.state.route.emergencies[i].createdDate, tz).format(ft)
          : '' + moment.tz(this.state.route.emergencies[i].createdDate, tz).format(ft),
      });
    }

    this.setState({ markers: markers, originalMarkers: markers, routePoints: routePoints });
  };
  getTimeZone = (route) => {
    if (route && route.tasks && route.tasks.length > 0) {
      if (route.tasks[0] && route.tasks[0].startLocation && route.tasks[0].startLocation.timeZone) {
        return route.tasks[0].startLocation.timeZone;
      }
    }
    return 'America/Mexico_City';
  };
  renderRouteResponse = (res) => {
    const routeResponse = res;

    if (routeResponse.route && routeResponse.route.expenses) {
      this.calculateRouteExpenses(routeResponse.route, routeResponse.route.expenses);
    }
    const routeData = this.calculateRouteData(routeResponse.route);
    routeResponse.route.km = routeData.kmCost;

    var startLocation;
    if (routeResponse.route.startPoint) {
      startLocation = routeResponse.route.startPoint;
    } else {
      startLocation = routeResponse.route.agent.location;
      startLocation.idLocation = 0;
    }
    var endLocation = routeResponse.route.endPoint;

    this.setState({
      loading: false,
      route: routeResponse.route,
      timeZone: this.getTimeZone(routeResponse.route),
      items: routeResponse.route.tasks,
      originalItems: routeResponse.route.tasks,
      routeExpensesPreferences: routeResponse.routeExpensesPreferences,
      km: routeData.km,
      kmRouteCost: '$ ' + routeData.kmCost,
      startLocation: startLocation,
      endLocation: endLocation,
    });

    this.getMarkers();

  };
  calculateRouteData = (route) => {
    const km = this.getKm(route.metersValue);
    const kmCost = this.getKMCost(route);

    return { kmCost: kmCost, km: km };
  };
  setTaskToRouteResponse = (res) => {
    const routeResponse = res;

    if (routeResponse.route) {
      let tasks = this.state.items;
      routeResponse.task.added = true;
      tasks.splice(this.state.position, 0, routeResponse.task);
      this.getMarkers();
      this.setState({ idTask: undefined, items: tasks });
    }
  };
  getTaskById = () => {
    const body = { folio: this.state.idTask };
    const loadingConfig = { dispatch: this.props.dispatch }
    const onSuccess = this.setTaskToRouteResponse;
    const onError = console.log

    getRouteTaskFolioRequest(body, onSuccess, onError, loadingConfig)
  };
  getKm = (value) => {
    let km = parseFloat(value) / 1000;
    let result = km + ' km';

    return result;
  };
  getTime = (date) => {
    date = Number(date);
    const hours = Math.floor(date / 3600);
    const minutes = Math.floor((date % 3600) / 60);
    const seconds = Math.floor((date % 3600) % 60);

    const hoursDisplay =
      hours > 0
        ? hours + (hours == 1 ? ' ' + this.props.lan.hour + ', ' : ' ' + this.props.lan.hours + ' ')
        : '';
    const minutesDisplay =
      minutes > 0
        ? minutes +
        (minutes == 1 ? ' ' + this.props.lan.minute + ', ' : ' ' + this.props.lan.minutes + ' ')
        : '';
    const secondsDisplay =
      seconds > 0
        ? seconds +
        (seconds == 1 ? ' ' + this.props.lan.second : ' ' + this.props.lan.seconds + ' ')
        : '';
    return hoursDisplay + minutesDisplay + secondsDisplay;
  };
  getTaskNumberSelect = () => this.state.items.map((item, i) => this.getOption(i));
  getOption = (element) => {
    return <option value={element}>{element + 1}</option>;
  };
  validateAddTask = () => {
    if (this.state.add && this.state.idTask) {
      this.getTaskById();
    } else {
      this.setState({ add: !this.state.add });
    }
  };
  onIdTaskChange = (event) => {
    let value = event.target.value;

    if (value && value !== '') {
      this.setState({ idTask: value });
    } else {
      this.setState({ idTask: undefined });
    }
  };
  deleteTaskFromRoute = (index) => {
    let tasks = this.state.items;
    tasks.splice(index, 1);
    this.setState({ items: tasks });
  };
  formatDate = (dateInMillis) => {
    var formattedDate = moment(dateInMillis).format('DD-MM-YYYY HH:mm');

    return formattedDate;
  };
  handleFromDate = (date) => {
    if (date == null) {
      this.setState({ items: this.state.originalItems, tasksToShow: [], markers: [] });
      this.setDefaultTasksMarkers();
    }
    this.setState({
      from: date,
    });
  };
  handleToDate = (date) => {
    if (date && this.state.from && date.getTime() >= this.state.from.getTime()) {
      this.setState(
        {
          to: date,
          offset: 0,
          tasksToShow: [],
        },
        () => this.getTasks()
      );
    }
  };
  getTasks = () => {
    const from = this.state.from;
    const to = this.state.to;

    const body = {
      requestType: 'GET_TASK_TO_SHOW',
      fromYear: from.getFullYear(),
      fromMonth: from.getMonth(),
      fromDay: from.getDate(),
      toYear: to.getFullYear(),
      toMonth: to.getMonth(),
      toDay: to.getDate(),
      offset: this.state.offset,
      limit: this.state.limit,
    };

    const onSuccess = this.renderTasks;
    const onError = console.log
    const loadingConfig = { dispatch: this.props.dispatch }

    getRouteTaskToShowRequest(body, onSuccess, onError, loadingConfig)
  };
  renderTasks = (res) => {
    let markers = this.state.originalMarkers;
    if (res) {

      if (res && res.services) {
        if (!markers && markers.length === 0) {
          markers = [];
        }

        if (res.services.length > 0) {
          const tasks = res.services;
          let allTasks = this.state.tasksToShow.concat(tasks);

          this.setState({
              markers: markers,
              tasksToShow: allTasks,
              mycount: res.total,
              showTasks: true,
              offset: this.state.offset + this.state.limit,
            },
            () => this.getMarkers()
          );
        }
      } else {
        this.setState({ markers: markers, showTasks: true, tasksToShow: [] }, () =>
          this.getMarkers()
        );
      }
    } else {
      this.setState({ markers: markers, showTasks: true, tasksToShow: [] }, () =>
        this.getMarkers()
      );
    }
  };
  handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      this.setState({
        showTasksResult: true,
        opacity: 0,
      });
    }
  };
  onChangeInitialMap() {
    if (this.state.initialMap) {
      this.setState({ initialMap: false });
    }
  };
  refresh = () => {
    let body = Request.getRouteById(this.props.idRoute);
    const onSuccess = this.renderRouteResponse;
    const loadingConfig = { dispatch: this.props.dispatch }
    getRouteByIdRequest(body, onSuccess, null, loadingConfig);
  };
  calculateRouteExpenses = (route, preferences) => {
    const kmCost = this.getKMCost(route);
    const kmCostWithExpenses = this.getKMCostWithExpenses(kmCost, preferences);
    const totalCost = this.getTotalCost(kmCostWithExpenses, preferences);

    this.setState({
      kmCost: kmCost,
      kmCostWithExpenses: kmCostWithExpenses,
      totalCost: totalCost,
    });
  };
  getTotalCost = (kmCostWithExpenses, preferences) => {
    var total = parseFloat(kmCostWithExpenses);

    if (preferences.defaultExpenses) {
      preferences.defaultExpenses.map((element, index) => {
        if (element.id !== 3) {
          total = total + element.value;
        }
      });
      preferences.dynamicExpenses.map((element, index) => {
        if (element.id !== 3) {
          total = total + element.value;
        }
      });
    }

    return total;
  };
  getKMCost = (props) => {
    try {
      let cost = ((props.metersValue * props.kmCost) / 1000).toFixed(2);

      return cost;
    } catch (error) {
      return 0.0;
    }
  };
  isValidThePercentageKm = (preferences) => {
    return (
      preferences &&
      preferences.defaultExpenses &&
      preferences.defaultExpenses.expensesKm &&
      typeof preferences.defaultExpenses.expensesKm === 'number' &&
      preferences.defaultExpenses.expensesKm > 0 &&
      preferences.defaultExpenses.expensesKm < 101
    );
  };
  getKMCostWithExpenses = (kmCost, preferences) => {
    try {
      let cost = kmCost;

      const isValid = this.isValidThePercentageKm(preferences);
      if (isValid) {
        let percentage = preferences.percentageKm;
        percentage = percentage / 100;
        percentage = percentage + 1;

        cost = (cost * percentage).toFixed(2);
      }
      return cost;
    } catch (error) {
      return 0.0;
    }
  };
  getActivityTime = (millis) => {
    const date = new Date(millis);
    var hour, minutes;

    if (date.getHours() < 10) {
      hour = '0' + date.getHours();
    } else {
      hour = date.getHours();
    }

    if (date.getMinutes() < 10) {
      minutes = '0' + date.getMinutes();
    } else {
      minutes = date.getMinutes();
    }
    return hour + ' : ' + minutes + ' hrs';
  };
  getActivityDate = (millis) => {
    const date = new Date(millis);
    const month = date.toLocaleString('es-es', { month: 'long' });
    return date.getDate() + ' - ' + month + ' - ' + date.getFullYear();
  };
  getActivityUser = (element) => {
    let name = '';
    let image = ProfileImage;
    if (element.agent) {
      name = element.agent.name + ' ' + element.agent.lastName;
      if (element.agent.profileImage) {
        image = element.agent.profileImage;
      }
    } else if (element.clientUser) {
      name = element.clientUser.name + ' ' + element.clientUser.lastName;
      if (element.clientUser.profileImage) {
        image = element.clientUser.profileImage.scalePath;
      }
    }

    return (
      <TableCell align='left' className='rd-activity-table-cell rd-activity-user-image'>
        <Image src={image} className='rd-activity-user-pic d-block mx-auto mb-2' roundedCircle />
        <span className='rd-activity-user-text'>{name}</span>
      </TableCell>
    );
  };
  getEmergencyDate = (emergency) => {
    return moment.tz(emergency.createdDate, this.state.timeZone).format('DD-MM-YYYY hh:mm a');
  };
  hideModal = (onClose) => {
    onClose();
  };
  setDefaultFalse() {
    this.setState({
      showTasksResult: false,
      opacity: 1,
    });
  };
  setDefaultFalseModal(task, position) {
    //this.state.position;
    let tasks = this.state.items;
    var canInsert = true;
    for (let i = 0; i < this.state.items.length; i++) {
      if (task.idTask == this.state.items[i].idTask) {
        canInsert = false;
      }
    }

    if (canInsert) {
      tasks.splice(position, 0, task);
    }

    this.setState({ items: tasks });
    this.getMarkers();
    this.setState({
      showTasksResult: false,
      opacity: 1,
    });
  };
  closePopup = () => this.setState({ errorMessage: !this.state.errorMessage });
  renderRoute = () => {
    const inactiveSection = 'col text-center rd-nav-item';
    const activeSection = inactiveSection + ' rd-active';

    if (this.state.loading) {
      return <div align='center' className='route-details-loading-view'></div>;
    } else {
      return (
        <Container fluid>
          <Row className='mx-3 ml-5'>
            <Col className='col-sm-1 '>
              <Image src={RoutesImage} className='mr-2' />
            </Col>

            <Col className='col-sm-6'>
              <Navbar className='rd-navbar mb-3'>
                <Nav.Item
                  key='route-nav'
                  id='route-nav'
                  className={this.state.showRouteInfo ? activeSection : inactiveSection}
                >
                  <Nav.Link
                    id='route-nav-link'
                    className='rd-nav-title'
                    onClick={() =>
                      this.setState({
                        showActivity: false,
                        showRouteInfo: true,
                        showEmergencies: false,
                      },() => { this.refresh(); })
                    }
                  >
                    {this.props.lan.route}
                  </Nav.Link>
                </Nav.Item>

                <Nav.Item
                  key='activity-nav'
                  id='activity-nav'
                  className={this.state.showActivity ? activeSection : inactiveSection}
                >
                  <Nav.Link
                    className='rd-nav-title'
                    onClick={() =>
                      this.setState({
                        showActivity: true,
                        showRouteInfo: false,
                        showEmergencies: false,
                      })
                    }
                  >
                    {this.props.lan.activity}
                  </Nav.Link>
                </Nav.Item>

                <Nav.Item
                  key='emergencies-nav'
                  id='emergencies-nav'
                  className={this.state.showEmergencies ? activeSection : inactiveSection}
                >
                  <Nav.Link
                    className='rd-nav-title'
                    onClick={() =>
                      this.setState({
                        showActivity: false,
                        showRouteInfo: false,
                        showEmergencies: true,
                      })
                    }
                  >
                    {this.props.lan.incidences}
                  </Nav.Link>
                </Nav.Item>
              </Navbar>
            </Col>

            <Col sm={5}>
              <Row className={'justify-content-end mr-2'}>
                <Col sm={'auto'} className={'no-padding'}>
                  <Image
                    src={RefreshIcon}
                    className='rd-click-image'
                    alt='Refresh'
                    onClick={() => {
                      this.refresh();
                    }}
                  />
                </Col>

                <Col className='col-sm-1'>
                  <Image
                    src={cancelIcon}
                    className='mr-2 rd-click-image'
                    onClick={this.props.onClose}
                  />
                </Col>
              </Row>
            </Col>
          </Row>

          {this.state.showRouteInfo ? (
            <Row className='mx-4'>
              <Col className='col-sm-6 offset-sm-6 mb-3'>
                <Row
                  className={
                    this.state.datesError ? 'Fielder-input-border-alert' : 'Fielder-input-border'
                  }
                >
                  <Col sm={'auto'}>
                    <img src={CalendarIcon} className='icon my-2' alt='' />
                  </Col>
                  <Col>
                    <label>
                      <DatePicker
                        selected={this.state.from} // seleccionada fecha
                        onChange={this.handleFromDate}
                        minTime={this.state.minTime}
                        id='input-date-from'
                        showMonthDropdown
                        showYearDropdow
                        maxTime={new Date().setHours(23, 59)}
                        dateFormat='dd/MM/yyyy' // Formato de fecha
                        className='MyOperation-eschedule form-control mt-1 text-left'
                        placeholderText='De'
                      />
                      <img src={DropDown} className='icon my-2 dropDownCalendar' alt='' />
                    </label>
                  </Col>
                  <Col sm={'auto'} className={this.state.from ? '' : 'rd-disable'}>
                    <img
                      src={CalendarIcon}
                      className='icon my-2 MyOperation-img-input Fielder-icon-button'
                      alt=''
                    />
                  </Col>
                  <Col className={this.state.from ? '' : 'rd-disable'}>
                    <label>
                      <DatePicker
                        selected={this.state.to}
                        onChange={this.handleToDate}
                        minTime={this.state.minTime}
                        showMonthDropdown
                        showYearDropdow
                        maxTime={new Date().setHours(23, 59)}
                        dateFormat='dd/MM/yyyy'
                        className='MyOperation-eschedule form-control mt-1 text-left'
                        placeholderText='A'
                      />
                      <img
                        src={DropDown}
                        className='icon my-2 dropDownCalendar Fielder-icon-button'
                        alt=''
                      />
                    </label>
                  </Col>
                </Row>
              </Col>
              {this.state.showTasks && (
                <Col className='col-sm-4 offset-sm-8 mb-3'>
									<span className='rd-tasks-to-show'>
										{this.state.tasksToShow.length +
                      ' ' +
                      this.props.lan.tasks +
                      ' ' +
                      this.props.lan.from +
                      ' ' +
                      this.state.mycount}
									</span>
                  {this.state.offset < this.state.mycount && (
                    <Button className='rd-clear-button' onClick={this.getTasks}>
                      <u>{this.props.lan.showMore}</u>
                    </Button>
                  )}
                </Col>
              )}
              <Col sm={3}>
                <Row className='mx-1'>
                  <Row className='mx-1 full-width'>
                    <Col id='route-id' className='p-2'>
                      <Col sm={12} className='p-0'>
                        <span className='label-input'>{this.props.lan.routeNumber}</span>
                      </Col>
                      <Col sm={12} className='p-0'>
                        <span className='route-text-large'>{this.state.route.id}</span>
                      </Col>
                    </Col>
                    <Col id='route-status' className='mt-1 p-2'>
                      <RouteStatus value={this.state.route.status} {...this.props} />
                    </Col>

                    {this.state.route.status !== 4 &&
                      this.state.route.status !== 5 &&
                      this.state.isAllowedRouteEdit && (
                        <Col sm={3} className='p-2 my-auto'>
                          <Image
                            src={RepositionIcon}
                            className='Fielder-icon mx-2 Fielder-icon-button'
                            alt='Change Position'
                            onClick={() =>
                              this.setState({ editable: !this.state.editable, add: false })
                            }
                          />

                          {this.state.showRouteExpenses && this.state.routeExpensesPreferences && (
                            <Image
                              src={ExpensesIcon}
                              className='Fielder-icon mx-2 Fielder-icon-button'
                              alt='Change Position'
                              onClick={() =>
                                this.setState({ configExpenses: !this.state.configExpenses })
                              }
                            />
                          )}
                        </Col>
                      )}
                  </Row>
                </Row>
                <Row className='mx-1 mt-3'>
                  <Col sm={12} className={'mt-1'}>
                    <Row>
                      <Col className={'label-input '}>{this.props.lan.routeStartPointTitle}</Col>
                    </Row>
                    <Row>
                      <Col id={'route-name'} className={'rd-text'}>
                        <input
                          type='text'
                          className={'route-details-input '}
                          defaultValue={this.state.startLocation.address}
                          readOnly={true}
                          style={{ width: '100%' }}
                        />
                      </Col>
                      {this.state.route.status !== 3 &&
                        this.state.route.status !== 4 &&
                        this.state.route.status !== 5 &&
                        this.state.isAllowedRouteEdit &&
                        this.state.editable && (
                          <Col sm={1} className='da-mr-none'>
                            <img
                              src={editImageIcon}
                              className={'icon my-1'}
                              alt=''
                              onClick={() => {
                                this.setState({
                                  showEditRouteStartPoint: !this.state.showEditRouteStartPoint,
                                });
                              }}
                            />
                          </Col>
                        )}
                    </Row>
                  </Col>
                  <Col sm={12} className={'mt-1'}>
                    <Row>
                      <Col className={'label-input'}>{this.props.lan.routeEndPointTitle}</Col>
                    </Row>
                    <Row>
                      <Col id={'route-name'} className={'rd-text'}>
                        <input
                          type='text'
                          className={'route-details-input '}
                          defaultValue={
                            this.state.endLocation ? this.state.endLocation.address : null
                          }
                          readOnly
                          style={{ width: '100%' }}
                        />
                      </Col>

                      {this.state.route.status !== 4 &&
                        this.state.route.status !== 5 &&
                        this.state.isAllowedRouteEdit &&
                        this.state.editable && (
                          <Col sm={1} className='da-mr-none'>
                            <img
                              src={editImageIcon}
                              className={'icon my-1'}
                              alt=''
                              onClick={() => {
                                this.setState({
                                  showEditRouteEndPoint: !this.state.showEditRouteEndPoint,
                                });
                              }}
                            />
                          </Col>
                        )}
                    </Row>
                  </Col>
                  <Col sm={12} className={'mt-1'}>
                    <Row>
                      <Col className={'label-input '}>{this.props.lan.routeName}</Col>
                    </Row>
                    <Row>
                      <Col id={'route-name'} className={'rd-text'}>
                        <input
                          type='text'
                          className={'route-details-input '}
                          defaultValue={this.state.route.name}
                          readOnly={true}
                          style={{ width: '100%' }}
                        />
                      </Col>
                    </Row>
                  </Col>

                  {this.state.route.agent && (
                    <Col sm={12} className={'mt-4'}>
                      <Row>
                        <Col className={'label-input '}>{this.props.lan.agentName}</Col>
                      </Row>
                      <Row>
                        <Col id={'route-agent'} className={'rd-text'}>
                          <input
                            type='text'
                            className={'route-details-input '}
                            defaultValue={
                              this.state.route.agent.name + ' ' + this.state.route.agent.lastName
                            }
                            readOnly={true}
                            style={{ width: '90%' }}
                          />
                          <Image
                            src={DetailTaskIcon}
                            className='Fielder-icon Fielder-icon-button'
                            alt='Change Position'
                            style={{ width: '8%', marginLeft: '2%' }}
                            onClick={() => this.showDetailAgent(
                              this.state.route.agent.idAgent)}
                          />
                        </Col>
                      </Row>
                    </Col>
                  )}

                  {!this.state.route.agent && (
                    <Col sm={12} className={'mt-4'}>
                      <Row>
                        <Col className={'label-input '}>{this.props.lan.agentName}</Col>
                      </Row>
                      <Row>
                        <Col id={'route-agent'} className={'rd-text'}>
                          <input
                            type='text'
                            className={'route-details-input '}
                            defaultValue={this.props.lan.unassigned}
                            readOnly={true}
                            style={{ width: '90%' }}
                          />
                        </Col>
                      </Row>
                    </Col>
                  )}
                  <Col sm={12} className={'mt-4'}>
                    <Row>
                      <Col className={'label-input '}>{this.props.lan.executionDate}</Col>
                    </Row>
                    <Row>
                      <Col id={'route-executionDate'} className={'rd-text'}>
                        <input
                          type='text'
                          className={'route-details-input '}
                          defaultValue={this.state.route.executionFormattedDate}
                          readOnly={true}
                          style={{ width: '100%' }}
                        />
                      </Col>
                    </Row>
                  </Col>
                  {this.state.route.startedFormattedDate && (
                    <Col sm={12} className={'mt-4'}>
                      <Row>
                        <Col className={'label-input '}>{this.props.lan.startedFormattedDate}</Col>
                      </Row>
                      <Row>
                        <Col id={'route-startDate'} className={'rd-text'}>
                          <input
                            type='text'
                            className={'route-details-input '}
                            defaultValue={this.state.route.startedFormattedDate}
                            readOnly={true}
                            style={{ width: '100%' }}
                          />
                        </Col>
                      </Row>
                    </Col>
                  )}
                  {this.state.route.finishedFormattedDate && (
                    <Col sm={12} className={'mt-4'}>
                      <Row>
                        <Col className={'label-input '}>{this.props.lan.finishedFormattedDate}</Col>
                      </Row>
                      <Row>
                        <Col id={'route-finishDate'} className={'rd-text'}>
                          <input
                            type='text'
                            className={'route-details-input '}
                            defaultValue={this.state.route.finishedFormattedDate}
                            readOnly={true}
                            style={{ width: '100%' }}
                          />
                        </Col>
                      </Row>
                    </Col>
                  )}
                  <Col sm={12} className={'mt-4'}>
                    <Row>
                      <Col className={'label-input '}>{this.props.lan.timeTraveled}</Col>
                    </Row>
                    <Row>
                      <Col id={'route-estimatedTime'} className={'rd-text'}>
                        <input
                          type='text'
                          className={'route-details-input '}
                          defaultValue={this.getTime(this.state.route.estimatedTimeValue)}
                          readOnly={true}
                          style={{ width: '100%' }}
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col sm={12} className={'mt-4'}>
                    <Row>
                      <Col className={'label-input '}>{this.props.lan.distanceTraveled}</Col>
                    </Row>
                    <Row>
                      <Col id={'route-meters'} className={'rd-text'}>
                        <input
                          type='text'
                          className={'route-details-input '}
                          defaultValue={this.state.km}
                          readOnly={true}
                          style={{ width: '100%' }}
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col sm={12} className={'mt-4'}>
                    <Row>
                      <Col className={'label-input '}>{this.props.lan.routeCost + ' (km) '}</Col>
                    </Row>
                    <Row>
                      <Col id={'route-charge'} className={'rd-text'}>
                        <input
                          type='text'
                          className={'route-details-input '}
                          defaultValue={this.state.kmRouteCost}
                          readOnly={true}
                          style={{ width: '100%' }}
                        />
                      </Col>
                    </Row>
                  </Col>
                  {this.state.route.comment && this.state.route.status === 4 && (
                    <Col sm={12} className={'mt-4'}>
                      <Row>
                        <Col className={'label-input '}>{this.props.lan.cancelReason}</Col>
                      </Row>
                      <Row>
                        <Col id={'route-cancel-comment'} className={'rd-text'}>
                          <input
                            type='text'
                            className={'route-details-input '}
                            defaultValue={this.state.route.comment}
                            readOnly={true}
                            style={{ width: '100%' }}
                          />
                        </Col>
                      </Row>
                    </Col>
                  )}
                  {this.state.route.expenses &&
                    this.state.route.expenses.defaultExpenses &&
                    this.state.route.expenses.defaultExpenses.map((element, index) => {
                      if (element.enabled) {
                        return (
                          <div>
                            <Col sm={12} className={'mt-4'}>
                              <Row>
                                <Col className={'label-input '}>
                                  {element.name === 'expensesFood'
                                    ? this.props.lan.expensesFood
                                    : element.name === 'expensesSleeping'
                                      ? this.props.lan.expensesSleeping
                                      : element.name === 'expensesKm'
                                        ? this.props.lan.expensesKm
                                        : element.name}
                                </Col>
                              </Row>
                              <Row>
                                <Col id={'route-food-average'} className={'rd-text'}>
                                  <input
                                    type='text'
                                    className={'route-details-input '}
                                    defaultValue={
                                      element.name === 'expensesKm'
                                        ? '% ' + element.value
                                        : '$ ' + element.value
                                    }
                                    readOnly={true}
                                    style={{ width: '100%' }}
                                  />
                                </Col>
                              </Row>
                            </Col>
                          </div>
                        );
                      }
                    })}
                  {this.state.route.expenses &&
                    this.state.route.expenses.dynamicExpenses &&
                    this.state.route.expenses.dynamicExpenses.map((element, index) => {
                      if (element.enabled) {
                        return (
                          <div>
                            <Col sm={12} className={'mt-4'}>
                              <Row>
                                <Col className={'label-input '}>{element.name}</Col>
                              </Row>
                              <Row>
                                <Col id={'route-food-average'} className={'rd-text'}>
                                  <input
                                    type='text'
                                    className={'route-details-input '}
                                    defaultValue={'$ ' + element.value}
                                    readOnly={true}
                                    style={{ width: '100%' }}
                                  />
                                </Col>
                              </Row>
                            </Col>
                          </div>
                        );
                      }
                    })}
                </Row>
              </Col>
              <div className='col-sm-4'>
                {this.state.editable && (
                  <Row className='rd-add-task'>
                    {this.state.isAllowedRouteAddTask && ( //this.state.editable && this.state.add &&
                      <LightSpeed left>
                        <Col className='Fielder-input-border my-auto route-input '>
                          <Row className='mt-1 justify-content-center'>
                            <Image
                              src={SearchIcon}
                              className='fielder-icon mt-1 Fielder-icon-button'
                              alt='Search'
                            />
                            <input
                              type='text'
                              key='route-details-search'
                              className='Fielder-input no-border ml-2 mt-1'
                              placeholder={
                                this.props.lan.searchBy +
                                ' ID ' +
                                this.props.lan.and +
                                ' ' +
                                this.props.lan.folio
                              }
                              style={{ width: '80%' }}
                              onChange={this.onIdTaskChange}
                              onKeyPress={this.handleKeyPress}
                            />
                          </Row>
                        </Col>
                      </LightSpeed>
                    )}
                    {this.state.editable && this.state.add && (
                      <Row className='rd-add-task-row'>
                        <span className=' col-sm-8'>{this.props.lan.label_position_add_task}</span>

                        <select
                          className='custom-select col-sm-4'
                          onChange={this.onChangeTaskPosition}
                          value={this.state.position}
                        >
                          {this.getTaskNumberSelect()}
                        </select>
                      </Row>
                    )}
                  </Row>
                )}
                <Row className='mt-3'>
                  <DragDropContext onDragEnd={this.onDragEnd}>
                    <Scrollbars style={{ height: '550px' }} className='rd-timeline'>
                      <Droppable droppableId='droppable' style={{ height: 'inherit' }}>
                        {(provided, snapshot) => (
                          <div
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                            style={this.getListStyle(snapshot.isDraggingOver)}
                            className='rd-droppable-bg'
                          >
                            {this.state.items.map((element, i) => (
                              <Draggable
                                draggableId={`${element.idTask}-task-draggable`}
                                index={i}
                                style={{ width: '100%' }}
                                isDragDisabled={!this.state.isAllowedReorganizeRoute}
                              >
                                {(provided, snapshot) => {
                                  let taskType = '';

                                  if (this.state.taskTypes.taskTypeFunctionality) {
                                    let parents = getTaskTypeParents(
                                      element.serviceTypeId,
                                      this.state.taskTypes.types
                                    );
                                    taskType = parents.join(' > ');
                                  } else {
                                    switch (element.serviceTypeId) {
                                      case 1:
                                        taskType = this.props.lan.tasktype1;
                                        break;
                                      case 2:
                                        taskType = this.props.lan.tasktype2;
                                        break;
                                      case 3:
                                        taskType = this.props.lan.tasktype3;
                                        break;
                                      case 4:
                                        taskType = this.props.lan.tasktype4;
                                        break;
                                      default:
                                        taskType = '';
                                    }
                                  }

                                  return (
                                    <div className='row' style={{ maxWidth: '100%' }}
                                    >
                                      <div
                                        className={
                                          'col ml-1  rd-list-item ' +
                                          getStatus(element.status) +
                                          ' ' +
                                          (this.state.editable && 'route-details-editable ')
                                        }
                                        ref={provided.innerRef}
                                        {...provided.dragHandleProps}
                                        {...provided.draggableProps}
                                        style={this.getItemStyle(
                                          snapshot.isDragging,
                                          provided.draggableProps.style
                                        )}
                                      >
                                        <Col xs='auto' className='ml-3'>
                                          <Row className='ml-1 my-auto'>
                                            <Col className='col-auto ml-3 no-padding'>
                                              <div className='rd-task-element-id'>
                                                {this.props.lan.idFielder}
                                              </div>
                                            </Col>

                                            <Col className='col-auto ml-1 no-padding'>
                                              <div
                                                id={'task-idFielder-' + i}
                                                className='rd-task-element-name'
                                              >
                                                {element.idTask}
                                              </div>
                                            </Col>
                                            <Col className='col rd-task-status'>
                                              <StatusFormatter
                                                {...this.props}
                                                value={element.status}
                                              />
                                            </Col>
                                          </Row>

                                          <Row className='ml-1 my-auto'>
                                            <Col className='col-auto ml-3 no-padding'>
                                              <div className='rd-task-element-id'>
                                                {this.props.lan.idCustom}
                                              </div>
                                            </Col>

                                            <Col className='col-auto no-padding ml-1'>
                                              <div
                                                id={'task-idCustom-' + i}
                                                className='rd-task-element-name2'
                                              >
                                                {element.idCustom}
                                              </div>
                                            </Col>
                                          </Row>

                                          <Row className='ml-1 my-auto'>
                                            <Col className='col-auto ml-3 no-padding'>
                                              <div className='rd-task-element-id'>
                                                {this.props.lan.folio}
                                              </div>
                                            </Col>
                                            <Col className='col-auto no-padding ml-1'>
                                              <div
                                                id={'task-folio-' + i}
                                                className='rd-task-element-name2'
                                              >
                                                {element.folio
                                                  ? element.folio
                                                  : this.props.lan.noFolio}
                                              </div>
                                            </Col>
                                          </Row>

                                          <Row className='ml-1 my-auto'>
                                            <Col className='col-auto no-padding ml-3'>
                                              <div className='rd-task-element-id pr-1'>
                                                {this.props.lan.priority}
                                              </div>
                                            </Col>
                                            <Col className='col-auto pl-1 ml-1'>
                                              <div
                                                id={'task-severity-' + i}
                                                className={getSeverityClassName(element.severity)}
                                              >
                                                {getSeverityText(
                                                  element.severity,
                                                  this.props.lan,
                                                  element.severityName,
                                                )}
                                              </div>
                                            </Col>

                                            <Col className='col-auto pl-1  ml-3'>
                                              {element.countAssets > 0 ? (
                                                <img
                                                  src={AssetsIcon}
                                                  className='img-fluid mr-1 mb-2'
                                                  alt=''
                                                />
                                              ) : null}
                                              {element.countInventories > 0 ? (
                                                <img
                                                  src={InventoryIcon}
                                                  className='img-fluid mr-1 mb-2'
                                                  alt=''
                                                />
                                              ) : null}
                                              {element.countImages > 0 ? (
                                                <img
                                                  src={ImagesIcon}
                                                  className='img-fluid mr-1 mb-2'
                                                  alt=''
                                                />
                                              ) : null}
                                              {element.countForms > 0 ? (
                                                <img
                                                  src={FormIcon}
                                                  className='img-fluid mr-1 mb-2'
                                                  alt=''
                                                />
                                              ) : null}
                                            </Col>
                                          </Row>

                                          <Row className='ml-1 my-auto'>
                                            <Col
                                              id={'task-type-' + i}
                                              sm={6}
                                              className='rd-task-element-act mt-2'
                                            >
                                              {taskType}
                                            </Col>
                                            <div className='col-6 '>
                                              <button
                                                type='submit'
                                                className='btn btn-outline-primary btn-success create-edit-modal-btnsave-size font-size-taskgroup buttonDetailcss'
                                                onClick={() => this.showDetailTaskDetail(element.idTask)}
                                              >
                                                {this.props.lan.showDetail}
                                              </button>
                                            </div>
                                          </Row>

                                          <Row className='ml-1 my-auto'>
                                            <Col
                                              id={'task-executeTime-' + i}
                                              sm={12}
                                              className='rd-task-element-id'
                                            >
                                              {element.startTimeFormatted}
                                            </Col>
                                          </Row>

                                          {element.user ? (
                                            <Row className='ml-1 mt-3'>
                                              <Col className='col-auto ml-3 no-padding'>
                                                <div className='rd-task-element-id'>
                                                  {this.props.lan.client}
                                                </div>
                                              </Col>
                                              <Col className='col-auto no-padding ml-1'>
                                                <div
                                                  id={'task-iduser-' + i}
                                                  className='rd-task-element-name2'
                                                >
                                                  {element.user.name +
                                                    ' ' +
                                                    element.user.lastName}
                                                </div>
                                              </Col>
                                            </Row>
                                          ) : null}
                                          {element.branch ? (
                                            <Row className='ml-1 mt-3'>
                                              <Col className='col-auto ml-3 no-padding'>
                                                <div className='rd-task-element-id'>
                                                  {this.props.lan.branch}
                                                </div>
                                              </Col>
                                              <Col className='col-auto no-padding ml-1'>
                                                <div
                                                  id={'task-idBranch-' + i}
                                                  className='rd-task-element-name2'
                                                >
                                                  {(element.branch.idCustom
                                                    ? element.branch.idCustom + ' '
                                                    : '') + element.branch.name}
                                                </div>
                                              </Col>
                                            </Row>
                                          ) : null}
                                          <Row className='ml-1 '>
                                            <Col
                                              id={'task-address-' + i}
                                              sm={12}
                                              className='rd-task-element-location'
                                            >
                                              {element.startLocation.address}
                                            </Col>
                                          </Row>
                                          <Row className='ml-1 mt-3'>
                                            <Col className='col-auto '>
                                              <div className='rd-task-element-id'>
                                                {this.props.lan.originalDates}
                                              </div>
                                            </Col>
                                          </Row>
                                          <Row className='ml-1 my-auto'>
                                            <Col className='col'>
                                              <div className='rd-task-element-id'>
                                                {this.props.lan.startedFormattedDate}
                                              </div>
                                            </Col>
                                            <Col className='col'>
                                              <div className='rd-task-element-id'>
                                                {this.props.lan.finishedFormattedDate}
                                              </div>
                                            </Col>
                                          </Row>
                                          <Row className='ml-1 my-auto'>
                                            <Col className='col'>
                                              <div
                                                id={'task-startDate-' + i}
                                                className='rd-task-element-name2'
                                              >
                                                {element.startDateTimeRange
                                                  ? this.formatDate(element.startDateTimeRange)
                                                  : 'No date'}
                                              </div>
                                            </Col>
                                            <Col className='col'>
                                              <div
                                                id={'task-finishDate-' + i}
                                                className='rd-task-element-name2'
                                              >
                                                {element.endDateTimeRange
                                                  ? this.formatDate(element.endDateTimeRange)
                                                  : 'No date'}
                                              </div>
                                            </Col>
                                          </Row>
                                        </Col>
                                      </div>

                                      {this.state.editable && (
                                        <div className='col-sm-1 my-auto'>
                                          {this.state.isAllowedReorganizeRoute && (
                                            <Image src={RepositionSmallIcon} className='my-1' />
                                          )}
                                          {this.state.isAllowedDeleteTask && (
                                            <Image
                                              src={DeleteIcon}
                                              className='my-1'
                                              onClick={() => this.deleteTaskFromRoute(i)}
                                            />
                                          )}
                                        </div>
                                      )}
                                    </div>
                                  );
                                }}
                              </Draggable>
                            ))}
                            {provided.placeholder}
                          </div>
                        )}
                      </Droppable>
                    </Scrollbars>
                  </DragDropContext>
                </Row>
              </div>
              <Col>
                <div className='col-sm-12'>
                  <Map
                    googleMapURL={GOOGLE_URL_WITH_LIBRARIES}
                    loadingElement={<div style={{ height: `100%` }} />}
                    containerElement={<div style={{ height: `400px` }} />}
                    mapElement={<div style={{ height: `100%` }} />}
                    center={{ lat: 19.3901284, lng: -99.2896576 }}
                    zoom={15}
                    markersData={this.state.markers}
                    routePoints={this.state.routePoints}
                    origin={this.state.origin}
                    changeMap={this.state.initialMap}
                    onChangeInitialMap={this.onChangeInitialMap}
                  />
                </div>
                <Row className='mt-5 justify-content-center'>
                  {this.state.editable && (
                    <button className='Fielder-button' onClick={this.updateTaskOrders}>
                      {this.props.lan.save}
                    </button>
                  )}
                </Row>
              </Col>
            </Row>
          ) : null}
          {this.state.showActivity && (
            <Row className='rd-add-activity-view'>
              <Table className='rd-activity-table'>
                <TableBody>
                  {this.state.route.logs &&
                    this.state.route.logs.map((element, i) => (
                      <TableRow key={i} className='rd-activity-table-row'>
                        <TableCell align='left' className='rd-activity-table-cell'>
                          <img src={ClockIcon} className='rd-activity-table-pic mr-3 ml-5' alt='' />
                          {this.getActivityTime(element.createdDate)}
                        </TableCell>
                        <TableCell align='left' className='rd-activity-table-cell'>
                          {this.getActivityDate(element.createdDate)}
                        </TableCell>
                        <TableCell align='left' className='rd-activity-table-cell'>
                          {this.props.lan[LOC_ACTIVITY_TYPE + element.type]}
                        </TableCell>

                        {this.getActivityUser(element)}
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </Row>
          )}
          {this.state.showEmergencies && (
            <Row className='rd-add-activity-view rd-emergencies-table'>
              <span className='rd-emergencies-agent-span'>{this.props.lan.incidenceAgent}</span>
              {this.state.route.emergencies &&
                this.state.route.emergencies.map((element, i) => (
                  <Row key={i} className='rd-emergencies-row'>
                    <h4>{this.props.lan.incidenceCount + '' + (parseInt(i) + 1)}</h4>
                    <span>{this.getEmergencyDate(element)}</span>
                    <p>{element.emergencyText}</p>
                  </Row>
                ))}
            </Row>
          )}
        </Container>
      );
    }
  };
  editAgentModal = () => {
    this.props.fielderModal.setContent(null);
    this.props.fielderModal.closeModal(POP_EDIT_AGENT);
    const dynamicContent = (
      <AgentDetail
        {...this.props}
        showAction={() => {
          this.closeRenderModal();
        }}
        dataAgent={this.state.dataAgent}
        idAgent={this.state.idAgent}
      />
    );
    this.props.fielderModal.setContent(POP_EDIT_AGENT, dynamicContent);
    this.props.fielderModal.openModal(POP_EDIT_AGENT);
  };
  renderAgentModal = (showModal, titleKey, id, fullWidth = false) => {
    if (!showModal) return null;
    return (
      <Modal
        id={id}
        title={this.props.lan[titleKey]}
        icon={<AddAgentIcon sx={{ color: DeepSpaceGrey, width: '24px' }} />}
        fullWidth={fullWidth}
      />
    );
  };
  closeRenderModal = () => {
    this.setState({
      showDetailAgent: false
    }, () => {
      this.props.fielderModal.closeAllModals();
    });
  };
  render() {
    return (
      <React.Fragment>
        {this.renderAgentModal(
          this.state.showDetailAgent, 'detailAgentTitle', POP_EDIT_AGENT, true)}
        {this.state.errorMessage && (
          <ErrorMessage
            {...this.props}
            closeErrorMessage={() => this.closePopup()}
            message={this.state.message}
            showErrorMessage={this.state.errorMessage}
            icon={this.state.icon}
          />
        )}
        <div className='rd-body'>
          {this.state.showDetailTask && (
            <TaskDetails
              {...this.props}
              onClose={() => {
                this.setState({
                  showDetailTask: false,
                  idTask: null,
                });
              }}
              onCloseModal={(res, res1) => this.closeEditTaskPopup(res, res1)}
              idTasks={[this.state.idTask]}
              canNotEdit={true}
            />
          )}
          {this.state.showTasksResult && (
            <TaskSearchResultsPopup
              {...this.props}
              showPopup={true}
              search={this.state.idTask}
              setDefaultFalse={() => this.setDefaultFalse()}
              setDefaultFalseModal={(task, position) => this.setDefaultFalseModal(task, position)}
              sourceItems={this.state.items}
            />
          )}
          {this.state.showEditRouteEndPoint && (
            <EditRouteEndPoint
              {...this.props}
              endPoint={this.state.endLocation}
              onClose={() => {
                this.setState({
                  showEditRouteEndPoint: false,
                });
              }}
              onSaveEndPoint={(endPoint) => {
                this.setState({
                  endLocation: endPoint,
                  showEditRouteEndPoint: false,
                });
              }}
            />
          )}
          {this.state.showEditRouteStartPoint && (
            <EditRouteEndPoint
              {...this.props}
              endPoint={this.state.startLocation}
              onClose={() => {
                this.setState({
                  showEditRouteStartPoint: false,
                });
              }}
              onSaveEndPoint={(startPoint) => {
                this.setState({
                  startLocation: startPoint,
                  showEditRouteStartPoint: false,
                });
              }}
            />
          )}
          {this.state.configExpenses && (
            <EditExpenses
              {...this.props}
              route={this.state.route}
              onClose={() => {
                this.setState({
                  configExpenses: false,
                });
                this.refresh();
              }}
            />
          )}
          <this.renderRoute />
        </div>
      </React.Fragment>
    );
  };
}
const mapStateToProps = (state) => ({
  session: state.utils.session,
});
export default connect(mapStateToProps)(withSnackbar(RouteDetails));
export function withSnackbar(Component) {
  return function WrappedComponent(props) {
    const fielderMsg = useFielderSnackBar();
    return <Component {...props} fielderMsg={fielderMsg} />;
  }
}*/
